window.SCHEMATIC_CATALOG = {
  "GoFit 3, 6, 6 PLUS, 6 HEPA & 10": {
    "catalog_page": 30,
    "image_asset": "schematic-30.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1A",
        "part_number": "101928",
        "name": "Replacement Double Swivel Elbow Cuff",
        "in_netsuite": true,
        "handle": "proteam-101928-replacement-1-5-double-swivel-elbow-cuff-for-backpack-vacuums",
        "coord": {
          "x": 0.2495,
          "y": 0.1195
        }
      },
      {
        "callout": "1B",
        "part_number": "100694",
        "name": "Replacement Double Swivel Straight Cuff",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": null
      },
      {
        "callout": "2",
        "part_number": "107648",
        "name": "48\" Static-Dissipating Hose w/Non-Replaceable Elbow and Straight Cuffs",
        "in_netsuite": true,
        "handle": "proteam-103048-1-5-static-dissipating-hose-w-cuffs-for-backpack-vacuums",
        "coord": {
          "x": 0.1449,
          "y": 0.149
        }
      },
      {
        "callout": "2",
        "part_number": "100505",
        "name": "48\" Static-Dissipating Hose w/ Straight Cuffs",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1449,
          "y": 0.149
        }
      },
      {
        "callout": "3",
        "part_number": "100694",
        "name": "Replacement Double Swivel Straight Cuff",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": {
          "x": 0.1471,
          "y": 0.2399
        }
      },
      {
        "callout": "4",
        "part_number": "843694",
        "name": "Purple Cap",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2658,
          "y": 0.1473
        }
      },
      {
        "callout": "5",
        "part_number": "107313",
        "name": "Intercept Micro Filter (GoFit 10)",
        "in_netsuite": true,
        "handle": "proteam-107313-intercept-micro-filter-bags-for-super-coach-pro-10-backpack-vacuum",
        "coord": {
          "x": 0.2636,
          "y": 0.1675
        }
      },
      {
        "callout": "5",
        "part_number": "107314",
        "name": "Intercept Micro Filter (GoFit 6)",
        "in_netsuite": true,
        "handle": "proteam-107314-6-qt-intercept-micro-filter-bags-for-super-coach-pro-6-backpack-vacuums",
        "coord": {
          "x": 0.2636,
          "y": 0.1675
        }
      },
      {
        "callout": "5",
        "part_number": "107374",
        "name": "Intercept Micro Filter (GoFit 6 HEPA)",
        "in_netsuite": true,
        "handle": "proteam-107374-6-qt-intercept-micro-filter-bag-closed-collar-fits-gofit-6-gffp-ii-super-coach-pro-6-provac-fs-6-backpack-vacuums-10-pack",
        "coord": {
          "x": 0.2636,
          "y": 0.1675
        }
      },
      {
        "callout": "5",
        "part_number": "107666",
        "name": "Intercept Micro Filter (GoFit 3)",
        "in_netsuite": true,
        "handle": "proteam-107666-3-qt-intercept-micro-filter-bag-open-collar-fits-proteam-gofit-3-backpack-vacuum-10-pk",
        "coord": {
          "x": 0.2636,
          "y": 0.1675
        }
      },
      {
        "callout": "6",
        "part_number": "834000",
        "name": "Micro Cloth Filter (GoFit 10)",
        "in_netsuite": true,
        "handle": "proteam-834000-micro-cloth-filter-for-super-coach-pro-10",
        "coord": {
          "x": 0.2669,
          "y": 0.1944
        }
      },
      {
        "callout": "6",
        "part_number": "834072",
        "name": "Micro Cloth Filter (GoFit 6)",
        "in_netsuite": true,
        "handle": "proteam-834072-micro-cloth-filter-for-super-coach-pro-series-6-qt-backpack-vacuums",
        "coord": {
          "x": 0.2669,
          "y": 0.1944
        }
      },
      {
        "callout": "6",
        "part_number": "843966",
        "name": "Micro Cloth Filter (GoFit 3)",
        "in_netsuite": true,
        "handle": "proteam-843966-micro-cloth-filter-fits-gofit-3-backpack-vacuum",
        "coord": {
          "x": 0.2669,
          "y": 0.1944
        }
      },
      {
        "callout": "7",
        "part_number": "510779",
        "name": "Latch Assembly Complete w/ Retainer and Screw",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3322,
          "y": 0.3754
        }
      },
      {
        "callout": "8",
        "part_number": "834035-5",
        "name": "Gasket Tank 10 QT",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1351,
          "y": 0.3527
        }
      },
      {
        "callout": "8",
        "part_number": "834035-3",
        "name": "Gasket Tank 6 QT",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1351,
          "y": 0.3527
        }
      },
      {
        "callout": "8",
        "part_number": "834035-4",
        "name": "Gasket Tank 3 QT",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1351,
          "y": 0.3527
        }
      },
      {
        "callout": "9",
        "part_number": "847834",
        "name": "Filter Knob (GoFit 6 HEPA)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2527,
          "y": 0.2449
        }
      },
      {
        "callout": "10",
        "part_number": "847761",
        "name": "HEPA Filter (GoFit 6 HEPA)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2669,
          "y": 0.271
        }
      },
      {
        "callout": "11",
        "part_number": "510183",
        "name": "Dome Filter w/ Foam Media (includes: 10)",
        "in_netsuite": true,
        "handle": "proteam-510183-foam-media-filter-for-dome-filter",
        "coord": {
          "x": 0.2647,
          "y": 0.3114
        }
      },
      {
        "callout": "12",
        "part_number": "510184",
        "name": "Foam Filter Media for Dome Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2647,
          "y": 0.3224
        }
      },
      {
        "callout": "13",
        "part_number": "510777",
        "name": "Upper Motor Support w/ Gasket",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.268,
          "y": 0.3384
        }
      },
      {
        "callout": "14",
        "part_number": "847768",
        "name": "Upper Motor Support (GoFit 6 HEPA)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3486,
          "y": 0.3241
        }
      },
      {
        "callout": "15",
        "part_number": "510780",
        "name": "Motor Gaskets Upper and Lower",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2059,
          "y": 0.3687
        }
      },
      {
        "callout": "15",
        "part_number": "510812",
        "name": "Upper & Lower Motor Gaskets (GoFit 6 HEPA)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2059,
          "y": 0.3687
        }
      },
      {
        "callout": "16",
        "part_number": "844193",
        "name": "Motor Assembly 1300W",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2037,
          "y": 0.4066
        }
      },
      {
        "callout": "16",
        "part_number": "844545",
        "name": "Motor Assembly with Lead (GoFit 6 PLUS)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2037,
          "y": 0.4066
        }
      },
      {
        "callout": "16",
        "part_number": "847770",
        "name": "Motor Assembly (GoFit 6 HEPA)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2037,
          "y": 0.4066
        }
      },
      {
        "callout": "17",
        "part_number": "841933",
        "name": "Carbon Brush Set",
        "in_netsuite": true,
        "handle": "proteam-841933-carbon-brush-set-wolong-motor",
        "coord": {
          "x": 0.2505,
          "y": 0.4049
        }
      },
      {
        "callout": "18",
        "part_number": "510781",
        "name": "Lower Motor Support w/ Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2691,
          "y": 0.4453
        }
      },
      {
        "callout": "19",
        "part_number": "510776",
        "name": "Cover Wire w/ Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1906,
          "y": 0.4815
        }
      },
      {
        "callout": "20",
        "part_number": "843963",
        "name": "Upper Foam Pad",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1917,
          "y": 0.5126
        }
      },
      {
        "callout": "21",
        "part_number": "843964",
        "name": "Lower Foam Pad",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1917,
          "y": 0.5362
        }
      },
      {
        "callout": "22",
        "part_number": "510778",
        "name": "Lower Housing Assembly w/ Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1906,
          "y": 0.5648
        }
      },
      {
        "callout": "23",
        "part_number": "844488",
        "name": "Exhaust Filter Made from HEPA Media",
        "in_netsuite": true,
        "handle": "proteam-844488-exhaust-filter-made-from-hepa-media-fits-only-gofit-series",
        "coord": {
          "x": 0.2778,
          "y": 0.5909
        }
      },
      {
        "callout": "24",
        "part_number": "843848",
        "name": "Exhaust Filter Door",
        "in_netsuite": true,
        "handle": "proteam-834838-exhaust-filter-door-gofit",
        "coord": {
          "x": 0.3192,
          "y": 0.5547
        }
      },
      {
        "callout": "25",
        "part_number": "844073",
        "name": "Harness Complete Assembly",
        "in_netsuite": true,
        "handle": "proteam-844073-harness-complete-assembly-fits-gofit-series-backpack-vacuum-only",
        "coord": {
          "x": 0.2516,
          "y": 0.6313
        }
      },
      {
        "callout": "26",
        "part_number": "844665",
        "name": "Upper Harness Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2843,
          "y": 0.6515
        }
      },
      {
        "callout": "27",
        "part_number": "843939",
        "name": "Lower Harness Assembly",
        "in_netsuite": true,
        "handle": "proteam-843939-lower-harness-assyembly-fits-gofit-only",
        "coord": {
          "x": 0.3322,
          "y": 0.8443
        }
      },
      {
        "callout": "28",
        "part_number": "510771",
        "name": "Upper Harness Plate w/ Screw",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1536,
          "y": 0.7222
        }
      },
      {
        "callout": "29",
        "part_number": "510772",
        "name": "Lower Harness Plate w/ Screw",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2146,
          "y": 0.7694
        }
      },
      {
        "callout": "30",
        "part_number": "843842",
        "name": "Lower Harness Articulating Arm",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1209,
          "y": 0.7609
        }
      },
      {
        "callout": "31",
        "part_number": "843947",
        "name": "Harness Quick Adjuster Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3562,
          "y": 0.6978
        }
      },
      {
        "callout": "32",
        "part_number": "510773",
        "name": "Harness Quick Adjust Holder w/ Screw (GoFit 10)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3606,
          "y": 0.7424
        }
      },
      {
        "callout": "32",
        "part_number": "510774",
        "name": "Harness Quick Adjust Holder w/ Screw (GoFit 6)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3606,
          "y": 0.7424
        }
      },
      {
        "callout": "32",
        "part_number": "510775",
        "name": "Harness Quick Adjust Holder w/ Screw (GoFit 3)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3606,
          "y": 0.7424
        }
      },
      {
        "callout": "33",
        "part_number": "844156",
        "name": "Switch Box Assembly",
        "in_netsuite": true,
        "handle": "proteam-844156-switch-box-assembly-fits-gofit-backpack",
        "coord": {
          "x": 0.3693,
          "y": 0.521
        }
      },
      {
        "callout": "33",
        "part_number": "844156-2",
        "name": "Switch Box Assembly w/ Internal Electronics (GoFit 6 PLUS)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3693,
          "y": 0.521
        }
      },
      {
        "callout": "33",
        "part_number": "844156-1",
        "name": "Switch Box Assembly for GoFit PH service (GoFit PH)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3693,
          "y": 0.521
        }
      },
      {
        "callout": "34",
        "part_number": "510782",
        "name": "Yellow Cord Guide w/ Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3235,
          "y": 0.5219
        }
      },
      {
        "callout": "35",
        "part_number": "510783",
        "name": "Fastener Package",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3736,
          "y": 0.8569
        }
      },
      {
        "callout": null,
        "part_number": "101678",
        "name": "50' Extension Cord (Not shown)",
        "in_netsuite": true,
        "handle": "proteam-101678-50-16-gauge-extension-cord",
        "coord": null
      }
    ]
  },
  "GoFit 3 & 6 Cordless": {
    "catalog_page": 31,
    "image_asset": "schematic-31.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1A",
        "part_number": "101928",
        "name": "Replacement Double Swivel Elbow Cuff",
        "in_netsuite": true,
        "handle": "proteam-101928-replacement-1-5-double-swivel-elbow-cuff-for-backpack-vacuums",
        "coord": {
          "x": 0.232,
          "y": 0.133
        }
      },
      {
        "callout": "1B",
        "part_number": "100694",
        "name": "Replacement Double Swivel Straight Cuff",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": {
          "x": 0.3257,
          "y": 0.133
        }
      },
      {
        "callout": "2",
        "part_number": "100505",
        "name": "48\" Static-Dissipating Hose w/ Straight Cuffs",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1024,
          "y": 0.165
        }
      },
      {
        "callout": "3",
        "part_number": "100694",
        "name": "Replacement Swivel Cuff 1 ½\"",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": {
          "x": 0.1068,
          "y": 0.2744
        }
      },
      {
        "callout": "4",
        "part_number": "843694",
        "name": "Purple Cap",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2495,
          "y": 0.1633
        }
      },
      {
        "callout": "5",
        "part_number": "107314",
        "name": "Intercept Micro Filter (GoFit 6)",
        "in_netsuite": true,
        "handle": "proteam-107314-6-qt-intercept-micro-filter-bags-for-super-coach-pro-6-backpack-vacuums",
        "coord": {
          "x": 0.2582,
          "y": 0.197
        }
      },
      {
        "callout": null,
        "part_number": "107666",
        "name": "Intercept Micro Filter (GoFit 3)",
        "in_netsuite": true,
        "handle": "proteam-107666-3-qt-intercept-micro-filter-bag-open-collar-fits-proteam-gofit-3-backpack-vacuum-10-pk",
        "coord": null
      },
      {
        "callout": "6",
        "part_number": "834072",
        "name": "Micro Cloth Filter (GoFit 6)",
        "in_netsuite": true,
        "handle": "proteam-834072-micro-cloth-filter-for-super-coach-pro-series-6-qt-backpack-vacuums",
        "coord": {
          "x": 0.2571,
          "y": 0.2138
        }
      },
      {
        "callout": null,
        "part_number": "843966",
        "name": "Micro Cloth Filter (GoFit 3)",
        "in_netsuite": true,
        "handle": "proteam-843966-micro-cloth-filter-fits-gofit-3-backpack-vacuum",
        "coord": null
      },
      {
        "callout": "7",
        "part_number": "510779",
        "name": "Latch Assembly Complete w/ Retainer and Screw",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.0893,
          "y": 0.3022
        }
      },
      {
        "callout": "8",
        "part_number": "834035-3",
        "name": "Gasket Tank 6 QT Cordless",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.0871,
          "y": 0.3695
        }
      },
      {
        "callout": null,
        "part_number": "834035-4",
        "name": "Gasket Tank 3 QT Cordless",
        "in_netsuite": false,
        "handle": null,
        "coord": null
      },
      {
        "callout": "9",
        "part_number": "847650",
        "name": "Twist-On Dome Filter w/ HEPA Media",
        "in_netsuite": true,
        "handle": "proteam-847650-twist-on-dome-filter-w-hepa-media-gofit-cordless",
        "coord": {
          "x": 0.2593,
          "y": 0.2542
        }
      },
      {
        "callout": "10",
        "part_number": "510802",
        "name": "Upper Motor Support w/ Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2593,
          "y": 0.2769
        }
      },
      {
        "callout": "11",
        "part_number": "510803",
        "name": "Motor Gaskets Upper and Lower",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2625,
          "y": 0.3687
        }
      },
      {
        "callout": "12",
        "part_number": "510804",
        "name": "Motor Assembly 60V",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2865,
          "y": 0.3822
        }
      },
      {
        "callout": "13",
        "part_number": "510805",
        "name": "Lower Motor Support w/ Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2614,
          "y": 0.4167
        }
      },
      {
        "callout": "14",
        "part_number": "510806",
        "name": "Front Housing Assembly w/ Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3007,
          "y": 0.4411
        }
      },
      {
        "callout": "15",
        "part_number": "510807",
        "name": "Rear Housing Assembly w/ Screws w/ on/off switch",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1176,
          "y": 0.4318
        }
      },
      {
        "callout": "16",
        "part_number": "510808",
        "name": "Battery Housing Assembly w/ Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1231,
          "y": 0.5101
        }
      },
      {
        "callout": "17",
        "part_number": "844073",
        "name": "Harness Complete Assembly",
        "in_netsuite": true,
        "handle": "proteam-844073-harness-complete-assembly-fits-gofit-series-backpack-vacuum-only",
        "coord": {
          "x": 0.2538,
          "y": 0.5463
        }
      },
      {
        "callout": "18",
        "part_number": "844665",
        "name": "Upper Harness Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2887,
          "y": 0.5758
        }
      },
      {
        "callout": "19",
        "part_number": "843939",
        "name": "Lower Harness Assembly",
        "in_netsuite": true,
        "handle": "proteam-843939-lower-harness-assyembly-fits-gofit-only",
        "coord": {
          "x": 0.2745,
          "y": 0.7769
        }
      },
      {
        "callout": "20",
        "part_number": "510771",
        "name": "Upper Harness Plate w/ Screw",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1754,
          "y": 0.6204
        }
      },
      {
        "callout": "21",
        "part_number": "510772",
        "name": "Lower Harness Plate w/ Screw",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.134,
          "y": 0.7155
        }
      },
      {
        "callout": "22",
        "part_number": "843842",
        "name": "Lower Harness Articulating Arm",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1373,
          "y": 0.6633
        }
      },
      {
        "callout": "23",
        "part_number": "843947",
        "name": "Harness Quick Adjuster Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.402,
          "y": 0.6044
        }
      },
      {
        "callout": "24",
        "part_number": "510774",
        "name": "Harness Quick Adjust Holder w/ Screw (GoFit 6)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4412,
          "y": 0.6566
        }
      },
      {
        "callout": null,
        "part_number": "510775",
        "name": "Harness Quick Adjust Holder w/ Screw (GoFit 3)",
        "in_netsuite": false,
        "handle": null,
        "coord": null
      },
      {
        "callout": "25",
        "part_number": "510783",
        "name": "Fastener Package",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4368,
          "y": 0.7306
        }
      },
      {
        "callout": "26",
        "part_number": "107683",
        "name": "GoFit 4Ah Battery",
        "in_netsuite": true,
        "handle": "proteam-107683-gofit-cordless-4ah-battery",
        "coord": {
          "x": 0.4379,
          "y": 0.1481
        }
      },
      {
        "callout": "27",
        "part_number": "107684",
        "name": "GoFit 8Ah Battery",
        "in_netsuite": true,
        "handle": "proteam-107684-gofit-cordless-8ah-battery",
        "coord": {
          "x": 0.4379,
          "y": 0.218
        }
      },
      {
        "callout": "28",
        "part_number": "107685",
        "name": "GoFit Battery Charger and Cord",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4401,
          "y": 0.2778
        }
      },
      {
        "callout": "29",
        "part_number": "847718",
        "name": "GoFit Charger Cord",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4379,
          "y": 0.3485
        }
      },
      {
        "callout": "30",
        "part_number": "844754",
        "name": "Battery Button Latch",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4412,
          "y": 0.4049
        }
      }
    ]
  },
  "GoFree Flex Pro II": {
    "catalog_page": 32,
    "image_asset": "schematic-32.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1",
        "part_number": "101928",
        "name": "Replacement Double Swivel Elbow Cuff 1½\"",
        "in_netsuite": true,
        "handle": "proteam-101928-replacement-1-5-double-swivel-elbow-cuff-for-backpack-vacuums",
        "coord": {
          "x": 0.4237,
          "y": 0.1608
        }
      },
      {
        "callout": null,
        "part_number": "102715",
        "name": "Replacement Double Swivel Elbow Cuff 1¼\"",
        "in_netsuite": true,
        "handle": "protam-102715-replacement-double-swivel-elbow-cuff-1-25-fits-electric-power-nozzle-hose-only",
        "coord": null
      },
      {
        "callout": "2",
        "part_number": "107648",
        "name": "48\" Static-Dissipating Hose w/",
        "in_netsuite": true,
        "handle": "proteam-103048-1-5-static-dissipating-hose-w-cuffs-for-backpack-vacuums",
        "coord": {
          "x": 0.3159,
          "y": 0.2071
        }
      },
      {
        "callout": "3",
        "part_number": "100694",
        "name": "Replacement Double Swivel Straight Cuff",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": {
          "x": 0.3105,
          "y": 0.3056
        }
      },
      {
        "callout": null,
        "part_number": "103279",
        "name": "Replacement Swivel Cuff (Black) 1¼\"",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "4",
        "part_number": "833948",
        "name": "Top Cap (Purple)",
        "in_netsuite": true,
        "handle": "proteam-833948-purple-cap-for-supercoach-pro-unit",
        "coord": {
          "x": 0.4357,
          "y": 0.1801
        }
      },
      {
        "callout": "5",
        "part_number": "107314",
        "name": "Intercept Micro Filter (Open Collar)",
        "in_netsuite": true,
        "handle": "proteam-107314-6-qt-intercept-micro-filter-bags-for-super-coach-pro-6-backpack-vacuums",
        "coord": {
          "x": 0.4434,
          "y": 0.2045
        }
      },
      {
        "callout": null,
        "part_number": "107374",
        "name": "Intercept Micro Filter (Closed Collar)",
        "in_netsuite": true,
        "handle": "proteam-107374-6-qt-intercept-micro-filter-bag-closed-collar-fits-gofit-6-gffp-ii-super-coach-pro-6-provac-fs-6-backpack-vacuums-10-pack",
        "coord": null
      },
      {
        "callout": "6",
        "part_number": "834072",
        "name": "Micro Cloth Filter",
        "in_netsuite": true,
        "handle": "proteam-834072-micro-cloth-filter-for-super-coach-pro-series-6-qt-backpack-vacuums",
        "coord": {
          "x": 0.4455,
          "y": 0.2567
        }
      },
      {
        "callout": "7",
        "part_number": "510179",
        "name": "Latch and Retainer w/Lock Nut & Screw",
        "in_netsuite": true,
        "handle": "proteam-510179-latch-and-retainer-w-lock-nut-screw",
        "coord": {
          "x": 0.4477,
          "y": 0.3224
        }
      },
      {
        "callout": "8",
        "part_number": "510181",
        "name": "Gasket for Tank",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4423,
          "y": 0.3502
        }
      },
      {
        "callout": "9",
        "part_number": "510183",
        "name": "Dome Filter w/Foam Media (includes: 10)",
        "in_netsuite": true,
        "handle": "proteam-510183-foam-media-filter-for-dome-filter",
        "coord": {
          "x": 0.4368,
          "y": 0.447
        }
      },
      {
        "callout": "10",
        "part_number": "510184",
        "name": "Foam Filter Media for Dome Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4336,
          "y": 0.4596
        }
      },
      {
        "callout": "11",
        "part_number": "510193",
        "name": "Upper Motor Support w/Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4455,
          "y": 0.4891
        }
      },
      {
        "callout": "12",
        "part_number": "510741",
        "name": "Motor Gasket (GFFP II only)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4532,
          "y": 0.5152
        }
      },
      {
        "callout": null,
        "part_number": "840899",
        "name": "Motor Gasket (old)",
        "in_netsuite": false,
        "handle": null,
        "coord": null
      },
      {
        "callout": "13",
        "part_number": "510740",
        "name": "Motor/Fan (36VDC) w/Gasket (GFFP II only)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4303,
          "y": 0.5362
        }
      },
      {
        "callout": "14",
        "part_number": "510185",
        "name": "Cover Wire w/2 screws",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4336,
          "y": 0.585
        }
      },
      {
        "callout": "15",
        "part_number": "510742",
        "name": "Left/Right Baffles",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4423,
          "y": 0.6246
        }
      },
      {
        "callout": "16",
        "part_number": "510194",
        "name": "Lower Motor Support (5 screws)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4172,
          "y": 0.6313
        }
      },
      {
        "callout": "17",
        "part_number": "834042",
        "name": "Triangular Lower Foam Pad",
        "in_netsuite": true,
        "handle": "proteam-834042-triangular-lower-foam-pad",
        "coord": {
          "x": 0.4434,
          "y": 0.6481
        }
      },
      {
        "callout": "18",
        "part_number": "808380-0",
        "name": "Screw Pan CR #8 x ½\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.451,
          "y": 0.6675
        }
      },
      {
        "callout": "19",
        "part_number": "510216",
        "name": "Housing Assembly Lower w/Screws",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3312,
          "y": 0.6785
        }
      },
      {
        "callout": "20",
        "part_number": "107315",
        "name": "Exhaust Filter made from HEPA Media (2 pk)",
        "in_netsuite": true,
        "handle": "proteam-107315-super-coach-pro-series-hepa-filter-2-pk",
        "coord": {
          "x": 0.4488,
          "y": 0.681
        }
      },
      {
        "callout": "21",
        "part_number": "841708",
        "name": "Exhaust Filter Door w/ Latch",
        "in_netsuite": true,
        "handle": "proteam-833954-exhaust-filter-door-for-pro-series-backpack-vacuums",
        "coord": {
          "x": 0.4521,
          "y": 0.729
        }
      },
      {
        "callout": "22",
        "part_number": "808380-22",
        "name": "Screw Pan CR #8 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4248,
          "y": 0.7332
        }
      },
      {
        "callout": "23",
        "part_number": "843473",
        "name": "Switch Cord and Power Cord Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1013,
          "y": 0.1953
        }
      },
      {
        "callout": null,
        "part_number": "834249",
        "name": "Switch Cord and Power Cord Assembly",
        "in_netsuite": true,
        "handle": "proteam-834249-switch-and-powercord-for-go-free",
        "coord": null
      },
      {
        "callout": "24",
        "part_number": "105147",
        "name": "On/Off Switch",
        "in_netsuite": true,
        "handle": "proteam-105147-upright-vacuum-switch",
        "coord": {
          "x": 0.098,
          "y": 0.1557
        }
      },
      {
        "callout": "25",
        "part_number": "107043",
        "name": "Switch Box",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1656,
          "y": 0.1322
        }
      },
      {
        "callout": "26",
        "part_number": "843475",
        "name": "Switch Cord Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2244,
          "y": 0.1338
        }
      },
      {
        "callout": "27",
        "part_number": "841726",
        "name": "Battery Cord Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1743,
          "y": 0.1835
        }
      },
      {
        "callout": "28",
        "part_number": "840112",
        "name": "Upper Harness Assembly",
        "in_netsuite": true,
        "handle": "proteam-840112-upper-harness-assembly",
        "coord": {
          "x": 0.146,
          "y": 0.2197
        }
      },
      {
        "callout": "29",
        "part_number": "840011",
        "name": "FlexFit Harness Assembly (includes: 28-37)",
        "in_netsuite": true,
        "handle": "proteam-840011-flexfit-harness-assembly-for-super-coachpro-vacuum-cleaners",
        "coord": {
          "x": 0.0904,
          "y": 0.3443
        }
      },
      {
        "callout": "30",
        "part_number": "510192",
        "name": "Tensioning Straps",
        "in_netsuite": true,
        "handle": "proteam-510192-tensioning-straps",
        "coord": {
          "x": 0.2146,
          "y": 0.3695
        }
      },
      {
        "callout": "31",
        "part_number": "840114",
        "name": "Lower Harness Assembly (includes: 36, 37)",
        "in_netsuite": true,
        "handle": "proteam-840114-lower-harness-assembly",
        "coord": {
          "x": 0.1383,
          "y": 0.4453
        }
      },
      {
        "callout": "32",
        "part_number": "510301",
        "name": "Waist Belt Buckles and Straps Set",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1667,
          "y": 0.5152
        }
      },
      {
        "callout": "33",
        "part_number": "834051",
        "name": "5/16\" - 18x1 - 3/8\" Lock Screw (2 screws)",
        "in_netsuite": true,
        "handle": "834051-proteam-lock-screws-for-supercoach-pro-6-10-fs6",
        "coord": {
          "x": 0.2767,
          "y": 0.4907
        }
      },
      {
        "callout": "34",
        "part_number": "834043",
        "name": "Rectangular Upper Foam Pad",
        "in_netsuite": true,
        "handle": "proteam-834043-rectangular-upper-foam-pad",
        "coord": {
          "x": 0.2985,
          "y": 0.5185
        }
      },
      {
        "callout": "35",
        "part_number": "510186",
        "name": "Harness Spacers",
        "in_netsuite": true,
        "handle": "proteam-510186-harness-spacers-for-bottem-harness-supercoach-pro-6-10-fs6",
        "coord": {
          "x": 0.2233,
          "y": 0.5278
        }
      },
      {
        "callout": "36",
        "part_number": "510218",
        "name": "Upper Battery Housing",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2538,
          "y": 0.5614
        }
      },
      {
        "callout": "37",
        "part_number": "510217",
        "name": "Lower Battery Housing",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2952,
          "y": 0.6052
        }
      },
      {
        "callout": "38",
        "part_number": "510219",
        "name": "Battery Support",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2418,
          "y": 0.7138
        }
      },
      {
        "callout": "39",
        "part_number": "510220",
        "name": "Lead Assembly w/Screw",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1721,
          "y": 0.6178
        }
      },
      {
        "callout": "40",
        "part_number": "510221",
        "name": "Actuator w/Washer, Screw, Springs",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1057,
          "y": 0.6591
        }
      },
      {
        "callout": "41",
        "part_number": "107724",
        "name": "12Ah Battery",
        "in_netsuite": true,
        "handle": "proteam-107320-gofree-flex-pro-replacement-battery-12ah",
        "coord": {
          "x": 0.3366,
          "y": 0.6364
        }
      },
      {
        "callout": "42",
        "part_number": "107516",
        "name": "Battery Charger and Charger Cord",
        "in_netsuite": true,
        "handle": "proteam-107321-gofree-flex-pro-battery-charger",
        "coord": {
          "x": 0.2244,
          "y": 0.7458
        }
      },
      {
        "callout": "43",
        "part_number": "834678",
        "name": "Charger Cord",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3344,
          "y": 0.7626
        }
      }
    ]
  },
  "Super Coach Pro 6 & 10 / ProVac FS 6": {
    "catalog_page": 33,
    "image_asset": "schematic-33.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1A",
        "part_number": "101928",
        "name": "Replacement Double Swivel Elbow Cuff",
        "in_netsuite": true,
        "handle": "proteam-101928-replacement-1-5-double-swivel-elbow-cuff-for-backpack-vacuums",
        "coord": {
          "x": 0.4118,
          "y": 0.1726
        }
      },
      {
        "callout": "1B",
        "part_number": "100694",
        "name": "Replacement Double Swivel Straight Cuff (PV FS)",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": {
          "x": 0.2092,
          "y": 0.1995
        }
      },
      {
        "callout": "2",
        "part_number": "107648",
        "name": "48\" Static-Dissipating Hose w/",
        "in_netsuite": true,
        "handle": "proteam-103048-1-5-static-dissipating-hose-w-cuffs-for-backpack-vacuums",
        "coord": {
          "x": 0.2974,
          "y": 0.2205
        }
      },
      {
        "callout": "3",
        "part_number": "100694",
        "name": "Replacement Double Swivel Straight Cuff",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": {
          "x": 0.2908,
          "y": 0.3266
        }
      },
      {
        "callout": "4",
        "part_number": "833948",
        "name": "Top Cap (Purple)",
        "in_netsuite": true,
        "handle": "proteam-833948-purple-cap-for-supercoach-pro-unit",
        "coord": {
          "x": 0.4281,
          "y": 0.1911
        }
      },
      {
        "callout": null,
        "part_number": "833948-1",
        "name": "Top Cap (Black) (PV FS)",
        "in_netsuite": false,
        "handle": null,
        "coord": null
      },
      {
        "callout": "5",
        "part_number": "107313",
        "name": "Intercept Micro Filter (SCP 10)",
        "in_netsuite": true,
        "handle": "proteam-107313-intercept-micro-filter-bags-for-super-coach-pro-10-backpack-vacuum",
        "coord": {
          "x": 0.4412,
          "y": 0.2172
        }
      },
      {
        "callout": null,
        "part_number": "107314",
        "name": "Intercept Micro Filter (SCP 6 & PV FS)",
        "in_netsuite": true,
        "handle": "proteam-107314-6-qt-intercept-micro-filter-bags-for-super-coach-pro-6-backpack-vacuums",
        "coord": null
      },
      {
        "callout": "6",
        "part_number": "834000",
        "name": "Micro Cloth Filter (SCP 10)",
        "in_netsuite": true,
        "handle": "proteam-834000-micro-cloth-filter-for-super-coach-pro-10",
        "coord": {
          "x": 0.4401,
          "y": 0.2702
        }
      },
      {
        "callout": null,
        "part_number": "834072",
        "name": "Micro Cloth Filter (SCP 6 & PV FS)",
        "in_netsuite": true,
        "handle": "proteam-834072-micro-cloth-filter-for-super-coach-pro-series-6-qt-backpack-vacuums",
        "coord": null
      },
      {
        "callout": "7",
        "part_number": "510179",
        "name": "Latch and Retainer w/Lock Nut & Screw",
        "in_netsuite": true,
        "handle": "proteam-510179-latch-and-retainer-w-lock-nut-screw",
        "coord": {
          "x": 0.427,
          "y": 0.3106
        }
      },
      {
        "callout": "8",
        "part_number": "510180",
        "name": "Gasket for Tank (SCP 10)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4292,
          "y": 0.3519
        }
      },
      {
        "callout": null,
        "part_number": "510181",
        "name": "Gasket for Tank (SCP 6 & PV FS)",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "9",
        "part_number": "510183",
        "name": "Dome Filter w/Foam Media (includes: 10)",
        "in_netsuite": true,
        "handle": "proteam-510183-foam-media-filter-for-dome-filter",
        "coord": {
          "x": 0.4379,
          "y": 0.4562
        }
      },
      {
        "callout": "10",
        "part_number": "510184",
        "name": "Foam Filter Media for Dome Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4346,
          "y": 0.4731
        }
      },
      {
        "callout": "11",
        "part_number": "510193",
        "name": "Upper Motor Support w/Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4597,
          "y": 0.5101
        }
      },
      {
        "callout": "12",
        "part_number": "833951",
        "name": "Upper Motor Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4477,
          "y": 0.5404
        }
      },
      {
        "callout": "13",
        "part_number": "836099",
        "name": "Motor/Fan (120 V) (Wolong)",
        "in_netsuite": true,
        "handle": "proteam-834036-supercoach-pro-6-10-motor",
        "coord": {
          "x": 0.4248,
          "y": 0.564
        }
      },
      {
        "callout": "14",
        "part_number": "841933",
        "name": "Carbon Brush Set (Wolong)",
        "in_netsuite": true,
        "handle": "proteam-841933-carbon-brush-set-wolong-motor",
        "coord": {
          "x": 0.4183,
          "y": 0.5766
        }
      },
      {
        "callout": null,
        "part_number": "101720",
        "name": "Carbon Brush Set (Ametek)",
        "in_netsuite": true,
        "handle": "proteam-101720-black-carbon-brush-set-for-119347-amatek-motor",
        "coord": null
      },
      {
        "callout": "15",
        "part_number": "833952",
        "name": "Lower Motor Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.439,
          "y": 0.5926
        }
      },
      {
        "callout": "16",
        "part_number": "510185",
        "name": "Cover Wire w/2 screws",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4379,
          "y": 0.6136
        }
      },
      {
        "callout": "17",
        "part_number": "510194",
        "name": "Lower Motor Support (5 screws)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4477,
          "y": 0.6456
        }
      },
      {
        "callout": "18",
        "part_number": "834042",
        "name": "Triangular Lower Foam Pad",
        "in_netsuite": true,
        "handle": "proteam-834042-triangular-lower-foam-pad",
        "coord": {
          "x": 0.4477,
          "y": 0.6801
        }
      },
      {
        "callout": "19",
        "part_number": "834043",
        "name": "Rectangular Upper Foam Pad",
        "in_netsuite": true,
        "handle": "proteam-834043-rectangular-upper-foam-pad",
        "coord": {
          "x": 0.3115,
          "y": 0.5497
        }
      },
      {
        "callout": "20",
        "part_number": "808380-0",
        "name": "Screw Pan CR #8 x ½\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4564,
          "y": 0.6928
        }
      },
      {
        "callout": "21",
        "part_number": "510188",
        "name": "Lower Housing Assembly w/Screws",
        "in_netsuite": true,
        "handle": "proteam-510188-housing-assembly-lower-w-screws",
        "coord": {
          "x": 0.3268,
          "y": 0.7146
        }
      },
      {
        "callout": "22",
        "part_number": "107315",
        "name": "Exhaust Filter made from HEPA Media (2 pack)",
        "in_netsuite": true,
        "handle": "proteam-107315-super-coach-pro-series-hepa-filter-2-pk",
        "coord": {
          "x": 0.4651,
          "y": 0.7029
        }
      },
      {
        "callout": "23",
        "part_number": "841708",
        "name": "Exhaust Filter Door w/Latch",
        "in_netsuite": true,
        "handle": "proteam-833954-exhaust-filter-door-for-pro-series-backpack-vacuums",
        "coord": {
          "x": 0.4619,
          "y": 0.7677
        }
      },
      {
        "callout": "24",
        "part_number": "808380-22",
        "name": "Screw Pan CR #8 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3312,
          "y": 0.7727
        }
      },
      {
        "callout": "25",
        "part_number": "836225-1",
        "name": "Switch Cord and Power Cord Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1166,
          "y": 0.2365
        }
      },
      {
        "callout": null,
        "part_number": "836225",
        "name": "Switch Box, Full Assembly",
        "in_netsuite": true,
        "handle": "proteam-836225-switch-box-cord-assy-for-pro-series-backpacks-new-version",
        "coord": null
      },
      {
        "callout": "26",
        "part_number": "106066",
        "name": "On/Off Switch",
        "in_netsuite": true,
        "handle": "proteam-106066-switch-for-backpack-vacuums",
        "coord": {
          "x": 0.0959,
          "y": 0.271
        }
      },
      {
        "callout": "27",
        "part_number": "836554-1",
        "name": "Switch Box (PV FS)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1264,
          "y": 0.2652
        }
      },
      {
        "callout": null,
        "part_number": "836554",
        "name": "Switch Box (without power cord)",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "28",
        "part_number": "836480",
        "name": "Power Cord Assembly",
        "in_netsuite": true,
        "handle": "proteam-836480-power-cord-assy",
        "coord": {
          "x": 0.2102,
          "y": 0.3123
        }
      },
      {
        "callout": "29",
        "part_number": "841724",
        "name": "Power Plug Assembly",
        "in_netsuite": true,
        "handle": "proteam-841724-power-plug-assembly-for-super-coach-pro-6-10-provac-fs-6",
        "coord": {
          "x": 0.1721,
          "y": 0.3215
        }
      },
      {
        "callout": "30",
        "part_number": "836478",
        "name": "Electrified Hose Receptacle (PV FS)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1503,
          "y": 0.2719
        }
      },
      {
        "callout": "31",
        "part_number": "840112",
        "name": "Upper Harness Assembly",
        "in_netsuite": true,
        "handle": "proteam-840112-upper-harness-assembly",
        "coord": {
          "x": 0.1187,
          "y": 0.3729
        }
      },
      {
        "callout": "32",
        "part_number": "840011",
        "name": "FlexFit Harness Assembly (includes: 31, 33-34)",
        "in_netsuite": true,
        "handle": "proteam-840011-flexfit-harness-assembly-for-super-coachpro-vacuum-cleaners",
        "coord": {
          "x": 0.0806,
          "y": 0.5539
        }
      },
      {
        "callout": "33",
        "part_number": "510192",
        "name": "Tensioning Straps",
        "in_netsuite": true,
        "handle": "proteam-510192-tensioning-straps",
        "coord": {
          "x": 0.1776,
          "y": 0.5236
        }
      },
      {
        "callout": "34",
        "part_number": "840114",
        "name": "Lower Harness Assembly (includes: 35, 36)",
        "in_netsuite": true,
        "handle": "proteam-840114-lower-harness-assembly",
        "coord": {
          "x": 0.1841,
          "y": 0.6768
        }
      },
      {
        "callout": "35",
        "part_number": "510738",
        "name": "Cord Holder",
        "in_netsuite": true,
        "handle": "proteam-102604-cord-holder-for-backpack-vacuums",
        "coord": {
          "x": 0.2702,
          "y": 0.6616
        }
      },
      {
        "callout": "36",
        "part_number": "510301",
        "name": "Waist Belt Buckles and Straps Set",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1285,
          "y": 0.6818
        }
      },
      {
        "callout": "37",
        "part_number": "834051",
        "name": "5/16\" - 18 x 13/8\" Lock Screw (2 screws)",
        "in_netsuite": true,
        "handle": "834051-proteam-lock-screws-for-supercoach-pro-6-10-fs6",
        "coord": {
          "x": 0.2876,
          "y": 0.6886
        }
      },
      {
        "callout": "38",
        "part_number": "510186",
        "name": "Harness Spacers",
        "in_netsuite": true,
        "handle": "proteam-510186-harness-spacers-for-bottem-harness-supercoach-pro-6-10-fs6",
        "coord": {
          "x": 0.2549,
          "y": 0.718
        }
      }
    ]
  },
  "Super CoachVac / Super QuarterVac": {
    "catalog_page": 34,
    "image_asset": "schematic-34.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1",
        "part_number": "101928",
        "name": "Replacement Double Swivel Elbow Cuff",
        "in_netsuite": true,
        "handle": "proteam-101928-replacement-1-5-double-swivel-elbow-cuff-for-backpack-vacuums",
        "coord": {
          "x": 0.3039,
          "y": 0.1667
        }
      },
      {
        "callout": "2",
        "part_number": "100197",
        "name": "Twist Cap Purple (SCV)",
        "in_netsuite": true,
        "handle": "proteam-100197-10qt-backpack-purple-twist-cap",
        "coord": {
          "x": 0.3617,
          "y": 0.2071
        }
      },
      {
        "callout": null,
        "part_number": "106073",
        "name": "Twist Cap Purple (SQV)",
        "in_netsuite": true,
        "handle": "proteam-106073-purple-twist-cap-for-6qt-backpack-vacuums",
        "coord": null
      },
      {
        "callout": "3",
        "part_number": "100331",
        "name": "Intercept Micro Filter (SCV)",
        "in_netsuite": true,
        "handle": "proteam-100331-10-quart-backpack-vacuum-bags",
        "coord": {
          "x": 0.3617,
          "y": 0.2306
        }
      },
      {
        "callout": null,
        "part_number": "100431",
        "name": "Intercept Micro Filter (SQV)",
        "in_netsuite": true,
        "handle": "proteam-100431-6-qt-bags-for-backpack-vacuums",
        "coord": null
      },
      {
        "callout": "4",
        "part_number": "100565",
        "name": "Micro Cloth Filter (SCV)",
        "in_netsuite": true,
        "handle": "proteam-100565-micro-cloth-bag-for-10qt-backpack-vacuums",
        "coord": {
          "x": 0.3682,
          "y": 0.2626
        }
      },
      {
        "callout": null,
        "part_number": "100564",
        "name": "Micro Cloth Filter (SQV)",
        "in_netsuite": true,
        "handle": "proteam-100564-micro-cloth-bag-for-6qt-backpack-vacuums",
        "coord": null
      },
      {
        "callout": "5",
        "part_number": "107648",
        "name": "48\" Static-Dissipating Hose w/",
        "in_netsuite": true,
        "handle": "proteam-103048-1-5-static-dissipating-hose-w-cuffs-for-backpack-vacuums",
        "coord": {
          "x": 0.4336,
          "y": 0.1591
        }
      },
      {
        "callout": "6",
        "part_number": "100694",
        "name": "Replacement Double Swivel Straight Cuff",
        "in_netsuite": true,
        "handle": "proteam-100694-replacement-1-5-swivel-cuff",
        "coord": {
          "x": 0.4248,
          "y": 0.33
        }
      },
      {
        "callout": "7",
        "part_number": "100030",
        "name": "Dome Filter w/Foam Media (includes: 8)",
        "in_netsuite": true,
        "handle": "proteam-100030-dome-filter-with-foam-media",
        "coord": {
          "x": 0.3747,
          "y": 0.3586
        }
      },
      {
        "callout": "8",
        "part_number": "100343",
        "name": "Foam Filter Media for Dome Filter",
        "in_netsuite": true,
        "handle": "proteam-100343-foam-filter-media-for-dome-filter-on-backpack-vacuums",
        "coord": {
          "x": 0.4728,
          "y": 0.3636
        }
      },
      {
        "callout": null,
        "part_number": "101220",
        "name": "High Filtration Disk (optional)",
        "in_netsuite": false,
        "handle": null,
        "coord": null
      },
      {
        "callout": "9",
        "part_number": "100586",
        "name": "Bottom Bumper",
        "in_netsuite": true,
        "handle": "proteam-100586-bottom-bumper",
        "coord": {
          "x": 0.4891,
          "y": 0.5253
        }
      },
      {
        "callout": "10",
        "part_number": "100014",
        "name": "Motor Gasket",
        "in_netsuite": true,
        "handle": "proteam-100014-tetraseal",
        "coord": {
          "x": 0.4815,
          "y": 0.5497
        }
      },
      {
        "callout": "11",
        "part_number": "105162",
        "name": "Motor/Fan (120 V) w/Crimps",
        "in_netsuite": true,
        "handle": "proteam-105162-backpack-vacuum-motor-w-crimps",
        "coord": {
          "x": 0.476,
          "y": 0.5741
        }
      },
      {
        "callout": null,
        "part_number": "100379",
        "name": "Motor Ground Wire Clamp Set w/Screws",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": null,
        "part_number": "100380",
        "name": "Motor Crimp Set: 4 Female, 4 Male,",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "12",
        "part_number": "105164",
        "name": "Carbon Brush Set (Domel)",
        "in_netsuite": true,
        "handle": "proteam-105164-carbon-brush-set-domel-motor",
        "coord": {
          "x": 0.4695,
          "y": 0.5901
        }
      },
      {
        "callout": null,
        "part_number": "101720",
        "name": "Carbon Brush Set (Ametek)",
        "in_netsuite": true,
        "handle": "proteam-101720-black-carbon-brush-set-for-119347-amatek-motor",
        "coord": null
      },
      {
        "callout": "13",
        "part_number": "100335",
        "name": "Motor Compression Ring w/Screws",
        "in_netsuite": true,
        "handle": "proteam-100335-motor-compression-ring-with-screws",
        "coord": {
          "x": 0.4858,
          "y": 0.6077
        }
      },
      {
        "callout": null,
        "part_number": "100378",
        "name": "Compression Ring Screws: 4 Screws",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "14",
        "part_number": "105044",
        "name": "Motor Shroud/Diffuser w/Screw Set: 2 Screws",
        "in_netsuite": true,
        "handle": "proteam-105044-motor-shroud-diffuser-set-w-screws",
        "coord": {
          "x": 0.4978,
          "y": 0.6675
        }
      },
      {
        "callout": "15",
        "part_number": "100597",
        "name": "Sound Muffler (SCV)",
        "in_netsuite": true,
        "handle": "proteam-100597-sound-muffler-for-10qt-backpack-vacuums",
        "coord": {
          "x": 0.4826,
          "y": 0.702
        }
      },
      {
        "callout": null,
        "part_number": "105800",
        "name": "Sound Muffler (SQV)",
        "in_netsuite": true,
        "handle": "proteam-100698-sound-exhaust-filter-for-6qt-backpack-vacuums",
        "coord": null
      },
      {
        "callout": "16",
        "part_number": "100368",
        "name": "Motor Mounting System Set: 3 Well Nuts,",
        "in_netsuite": true,
        "handle": "proteam-100368-motor-mount-system-for-cylinder-style-backpack-vacuums",
        "coord": {
          "x": 0.2985,
          "y": 0.5471
        }
      },
      {
        "callout": "17",
        "part_number": "101610",
        "name": "Switch Cord Assembly (includes: 18, 19)",
        "in_netsuite": true,
        "handle": "proteam-101610-backpack-vacuum-switch-cord-assembly",
        "coord": {
          "x": 0.1895,
          "y": 0.4529
        }
      },
      {
        "callout": null,
        "part_number": "101714",
        "name": "Switch Cord w/Crimps",
        "in_netsuite": true,
        "handle": "proteam-101714-switch-cord-for-provac-supercoach-superquartervac",
        "coord": null
      },
      {
        "callout": "18",
        "part_number": "106066",
        "name": "On/Off Switch (must use with #106287)",
        "in_netsuite": true,
        "handle": "proteam-106066-switch-for-backpack-vacuums",
        "coord": {
          "x": 0.1231,
          "y": 0.4857
        }
      },
      {
        "callout": "19",
        "part_number": "101472",
        "name": "Switch Box w/Velcro and New Lamb Switch",
        "in_netsuite": true,
        "handle": "proteam-101472-switch-box-w-velcro-and-switch",
        "coord": {
          "x": 0.1427,
          "y": 0.4402
        }
      },
      {
        "callout": null,
        "part_number": "106287",
        "name": "Switch Box w/Velcro and Screws",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "20",
        "part_number": "100641",
        "name": "Power Cord Assembly",
        "in_netsuite": true,
        "handle": "proteam-100641-backpack-vacuum-power-cord-assembly",
        "coord": {
          "x": 0.171,
          "y": 0.5185
        }
      },
      {
        "callout": "21",
        "part_number": "510738",
        "name": "Cord Holder",
        "in_netsuite": true,
        "handle": "proteam-102604-cord-holder-for-backpack-vacuums",
        "coord": {
          "x": 0.1166,
          "y": 0.3855
        }
      },
      {
        "callout": "22",
        "part_number": "100358",
        "name": "Shoulder Strap Plastic Adjustment Buckle (Top)1 ea. 1.59",
        "in_netsuite": true,
        "handle": "proteam-100358-buckle",
        "coord": {
          "x": 0.2429,
          "y": 0.2062
        }
      },
      {
        "callout": "23",
        "part_number": "100359",
        "name": "Waist Belt (includes: Buckle Set)",
        "in_netsuite": true,
        "handle": "proteam-100359-waistbelt-for-backpack-vacuums",
        "coord": {
          "x": 0.3246,
          "y": 0.3502
        }
      },
      {
        "callout": "24",
        "part_number": "100375",
        "name": "Barrel Nut Connection Set for Backplate",
        "in_netsuite": true,
        "handle": "proteam-105046-backplate-for-cylindrical-backpacks",
        "coord": {
          "x": 0.1874,
          "y": 0.3695
        }
      },
      {
        "callout": "25",
        "part_number": "100357",
        "name": "Shoulder Strap Plastic Adjustment Buckle",
        "in_netsuite": true,
        "handle": "proteam-100357-buckle",
        "coord": {
          "x": 0.1155,
          "y": 0.3325
        }
      },
      {
        "callout": "26",
        "part_number": "105046",
        "name": "Backplate",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1895,
          "y": 0.3039
        }
      },
      {
        "callout": "27",
        "part_number": "100716",
        "name": "Backplate (Black) Connection Set: 4 Screws",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1155,
          "y": 0.2374
        }
      },
      {
        "callout": "28",
        "part_number": "103166",
        "name": "Backplate System Complete (includes: 21-28)",
        "in_netsuite": true,
        "handle": "proteam-103166-backpack-vacuum-backplate-system-complete",
        "coord": {
          "x": 0.2375,
          "y": 0.4293
        }
      },
      {
        "callout": "29",
        "part_number": "107294",
        "name": "Thermal Protector",
        "in_netsuite": true,
        "handle": "proteam-107294-thermal-protector-for-cylinder-style-backpack-vacuums",
        "coord": {
          "x": 0.3028,
          "y": 0.5934
        }
      },
      {
        "callout": "30",
        "part_number": "106526",
        "name": "Dome Filter made from HEPA Media",
        "in_netsuite": true,
        "handle": "proteam-106526-hepa-dome-filter-for-backpack-vacuums",
        "coord": {
          "x": 0.2549,
          "y": 0.5976
        }
      }
    ]
  },
  "ProGen 12/15 (Page 1)": {
    "catalog_page": 35,
    "image_asset": "schematic-35.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1",
        "part_number": "842344",
        "name": "Handle Assembly",
        "in_netsuite": true,
        "handle": "proteam-835699-progen-12-15-handle-assembly",
        "coord": {
          "x": 0.1155,
          "y": 0.1785
        }
      },
      {
        "callout": "2",
        "part_number": "842345",
        "name": "Handle Tube Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3214,
          "y": 0.1498
        }
      },
      {
        "callout": "3",
        "part_number": "834740-1",
        "name": "15\" Power Cord w/Strain Relief 50'",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4194,
          "y": 0.1843
        }
      },
      {
        "callout": "4",
        "part_number": "835701",
        "name": "Handle Screw Nut Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2712,
          "y": 0.2315
        }
      },
      {
        "callout": "5",
        "part_number": "835686",
        "name": "15\" Base Cover Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2059,
          "y": 0.3148
        }
      },
      {
        "callout": "6",
        "part_number": "510252",
        "name": "Hose Power Head Assembly",
        "in_netsuite": true,
        "handle": "proteam-510252-hose-power-head-assembly-for-progen-uprights",
        "coord": {
          "x": 0.1373,
          "y": 0.4057
        }
      },
      {
        "callout": "7",
        "part_number": "835345",
        "name": "Washer Pan Screw M4",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2418,
          "y": 0.4015
        }
      },
      {
        "callout": "8",
        "part_number": "834797",
        "name": "Main Control Board",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2309,
          "y": 0.4276
        }
      },
      {
        "callout": "9",
        "part_number": "835683",
        "name": "Control Board Hall Effect Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4172,
          "y": 0.4562
        }
      },
      {
        "callout": "10",
        "part_number": "835676",
        "name": "15\" Foot Pedal Assembly",
        "in_netsuite": true,
        "handle": "proteam-835676-15-foot-pedal-assembly-for-progen-15",
        "coord": {
          "x": 0.4597,
          "y": 0.3923
        }
      },
      {
        "callout": "11",
        "part_number": "834788",
        "name": "Cap Button",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1264,
          "y": 0.4487
        }
      },
      {
        "callout": "12",
        "part_number": "834789",
        "name": "15\" Rear Wheel Shaft",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1939,
          "y": 0.4428
        }
      },
      {
        "callout": "13",
        "part_number": "834787",
        "name": "15\" Rear Wheel",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1852,
          "y": 0.4857
        }
      },
      {
        "callout": "14",
        "part_number": "834790",
        "name": "Retaining Ring",
        "in_netsuite": true,
        "handle": "proteam-834790-retaining-clips",
        "coord": {
          "x": 0.2549,
          "y": 0.4764
        }
      },
      {
        "callout": "15",
        "part_number": "834804",
        "name": "15\" Power Nozzle Base",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3246,
          "y": 0.516
        }
      },
      {
        "callout": "16",
        "part_number": "835684",
        "name": "Filter Housing Clamp Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.476,
          "y": 0.5042
        }
      },
      {
        "callout": "17",
        "part_number": "835350",
        "name": "15\" Brush Removal Cover Assembly",
        "in_netsuite": true,
        "handle": "proteam-835350-brush-removal-cover",
        "coord": {
          "x": 0.1002,
          "y": 0.5084
        }
      },
      {
        "callout": "18",
        "part_number": "835682",
        "name": "15\" Brush Release Button Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1122,
          "y": 0.5631
        }
      },
      {
        "callout": "19",
        "part_number": "834810",
        "name": "15\" Side Base Bumper",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1852,
          "y": 0.5126
        }
      },
      {
        "callout": "20",
        "part_number": "835675",
        "name": "Center Wheel Pivot Rod Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.0969,
          "y": 0.596
        }
      },
      {
        "callout": "21",
        "part_number": "834791",
        "name": "Center Wheel",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1961,
          "y": 0.5572
        }
      },
      {
        "callout": "22",
        "part_number": "835349",
        "name": "LED Strip Light Harness Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3105,
          "y": 0.5951
        }
      },
      {
        "callout": "23",
        "part_number": "834816",
        "name": "LED Strip Light Lens",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2821,
          "y": 0.6414
        }
      },
      {
        "callout": "24",
        "part_number": "835680",
        "name": "15\" Front Base Plate Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1285,
          "y": 0.7239
        }
      },
      {
        "callout": "25",
        "part_number": "834809",
        "name": "15\" Front Base Bumper",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1503,
          "y": 0.7997
        }
      },
      {
        "callout": "26",
        "part_number": "835679",
        "name": "Base Wire Brace",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3519,
          "y": 0.8098
        }
      },
      {
        "callout": "27",
        "part_number": "841818",
        "name": "15\" Brush Roller",
        "in_netsuite": true,
        "handle": "proteam-834807-15-brushroll-for-progen-15-upright",
        "coord": {
          "x": 0.4205,
          "y": 0.7778
        }
      },
      {
        "callout": "28",
        "part_number": "835681",
        "name": "15\" Rear Base Plate Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4662,
          "y": 0.7256
        }
      },
      {
        "callout": "29",
        "part_number": "835678",
        "name": "Timing Belt Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4074,
          "y": 0.6448
        }
      },
      {
        "callout": "30",
        "part_number": "835685",
        "name": "15\" Pulley Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4564,
          "y": 0.5522
        }
      },
      {
        "callout": "31",
        "part_number": "835677",
        "name": "Brush Roller Clutch Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.451,
          "y": 0.6313
        }
      }
    ]
  },
  "ProGen 12/15 (Page 2)": {
    "catalog_page": 36,
    "image_asset": "schematic-36.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1",
        "part_number": "510259",
        "name": "Hose Assembly",
        "in_netsuite": true,
        "handle": "proteam-510259-hose-for-progen-upright",
        "coord": {
          "x": 0.1547,
          "y": 0.1465
        }
      },
      {
        "callout": "2",
        "part_number": "835354",
        "name": "Filter Cover Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2974,
          "y": 0.154
        }
      },
      {
        "callout": "3",
        "part_number": "835696",
        "name": "Filter Lid Cam Lock Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4129,
          "y": 0.1768
        }
      },
      {
        "callout": "4",
        "part_number": "834688",
        "name": "Upright Transition Duct Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.354,
          "y": 0.2315
        }
      },
      {
        "callout": "5",
        "part_number": "834753",
        "name": "Filter Housing Spring Hose",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2462,
          "y": 0.2441
        }
      },
      {
        "callout": "6",
        "part_number": "510258",
        "name": "Extension Tube Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1601,
          "y": 0.2845
        }
      },
      {
        "callout": "7",
        "part_number": "835345",
        "name": "Washer Pan Screw M4",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3464,
          "y": 0.2635
        }
      },
      {
        "callout": "8",
        "part_number": "834691",
        "name": "Transition Duct Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2658,
          "y": 0.2744
        }
      },
      {
        "callout": "9",
        "part_number": "834687",
        "name": "Bag Cover Housing Plate",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3573,
          "y": 0.2828
        }
      },
      {
        "callout": "10",
        "part_number": "835697",
        "name": "Bag Cover Housing Interlock Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3911,
          "y": 0.2946
        }
      },
      {
        "callout": "11",
        "part_number": "834690",
        "name": "Bag Cover Gasket Plate",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.342,
          "y": 0.3418
        }
      },
      {
        "callout": "12",
        "part_number": "834730-3",
        "name": "Lid Rear Tree Gasket",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2516,
          "y": 0.3476
        }
      },
      {
        "callout": "13",
        "part_number": "834823",
        "name": "Bag Housing Rim",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2298,
          "y": 0.3678
        }
      },
      {
        "callout": "14",
        "part_number": "107377",
        "name": "Intercept Micro Filter,10 pack",
        "in_netsuite": true,
        "handle": "proteam-107377-intercept-micro-filter-bags-for-new-progen-12-15-10pk",
        "coord": {
          "x": 0.2375,
          "y": 0.404
        }
      },
      {
        "callout": "15",
        "part_number": "835698",
        "name": "Hinge with Rivet Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3464,
          "y": 0.3687
        }
      },
      {
        "callout": "16",
        "part_number": "835694",
        "name": "Carry Handle w/Tool Caddy Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4466,
          "y": 0.3157
        }
      },
      {
        "callout": "17",
        "part_number": "835351",
        "name": "Power Nozzle Adaptor Hose",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.158,
          "y": 0.4066
        }
      },
      {
        "callout": "18",
        "part_number": "835690",
        "name": "Filter Housing Harness Enclosure Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1634,
          "y": 0.4411
        }
      },
      {
        "callout": "19",
        "part_number": "834724",
        "name": "Extension Handle Clip",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3279,
          "y": 0.4503
        }
      },
      {
        "callout": "20",
        "part_number": "835358",
        "name": "Pan Screw M4 20mm",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.378,
          "y": 0.4141
        }
      },
      {
        "callout": "21",
        "part_number": "835693",
        "name": "Rear Bag Housing Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4477,
          "y": 0.4259
        }
      },
      {
        "callout": "22",
        "part_number": "834717",
        "name": "Exhaust Filter Cover",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.0697,
          "y": 0.5404
        }
      },
      {
        "callout": "23",
        "part_number": "107005",
        "name": "Exhaust Filter made from HEPA Media",
        "in_netsuite": true,
        "handle": "proteam-107005-proteam-replacement-hepa-filter",
        "coord": {
          "x": 0.1046,
          "y": 0.5497
        }
      },
      {
        "callout": "24",
        "part_number": "835687",
        "name": "15\" Front Bag Housing",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1013,
          "y": 0.5219
        }
      },
      {
        "callout": "25",
        "part_number": "834730",
        "name": "Bag Housing Tree Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1732,
          "y": 0.5143
        }
      },
      {
        "callout": "26",
        "part_number": "834730-1",
        "name": "Filter Housing Tree Gasket",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2288,
          "y": 0.5505
        }
      },
      {
        "callout": "27",
        "part_number": "835150",
        "name": "Filter Housing Gasket Separator",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2397,
          "y": 0.5951
        }
      },
      {
        "callout": "28",
        "part_number": "834718",
        "name": "Filter Housing Separator",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3159,
          "y": 0.5286
        }
      },
      {
        "callout": "29",
        "part_number": "834721",
        "name": "Motor Intake Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3115,
          "y": 0.5943
        }
      },
      {
        "callout": "30",
        "part_number": "835695",
        "name": "Bag Housing Pivot Sleeve Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2636,
          "y": 0.6263
        }
      },
      {
        "callout": "31",
        "part_number": "835688",
        "name": "Lower Cord Wrap Bracket Assembly",
        "in_netsuite": true,
        "handle": "proteam-835688-lower-cord-wrap-bracket-assembly",
        "coord": {
          "x": 0.0893,
          "y": 0.6347
        }
      },
      {
        "callout": "32",
        "part_number": "835689",
        "name": "Filter Housing Harness Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2462,
          "y": 0.7736
        }
      },
      {
        "callout": "33",
        "part_number": "834722",
        "name": "Foam Filter Housing",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2614,
          "y": 0.7475
        }
      },
      {
        "callout": "34",
        "part_number": "834730-2",
        "name": "Motor Housing Tree Gasket",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.354,
          "y": 0.7247
        }
      },
      {
        "callout": "35",
        "part_number": "834723",
        "name": "Bag Full Indicator Sensor",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2342,
          "y": 0.6869
        }
      },
      {
        "callout": "36",
        "part_number": "840042",
        "name": "Motor Support Gasket",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3094,
          "y": 0.6717
        }
      },
      {
        "callout": "37",
        "part_number": "835344",
        "name": "Motor Harness",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2985,
          "y": 0.6515
        }
      },
      {
        "callout": "38",
        "part_number": "834705",
        "name": "Motor Assembly (includes: 45)",
        "in_netsuite": true,
        "handle": "proteam-834705-progen-motor-12-15",
        "coord": {
          "x": 0.3486,
          "y": 0.6254
        }
      },
      {
        "callout": "39",
        "part_number": "834696",
        "name": "Blower Gasket Housing",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3017,
          "y": 0.6094
        }
      },
      {
        "callout": "40",
        "part_number": "834697",
        "name": "Inlet Motor Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3704,
          "y": 0.6069
        }
      },
      {
        "callout": "41",
        "part_number": "834701",
        "name": "Motor Mount Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4423,
          "y": 0.6524
        }
      },
      {
        "callout": "42",
        "part_number": "835692",
        "name": "Motor Pulley Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4641,
          "y": 0.6633
        }
      },
      {
        "callout": "43",
        "part_number": "834704",
        "name": "Foam Motor Housing",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4292,
          "y": 0.7062
        }
      },
      {
        "callout": "44",
        "part_number": "835691",
        "name": "Motor Housing Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3312,
          "y": 0.771
        }
      },
      {
        "callout": "45",
        "part_number": "835714",
        "name": "Motor Brush",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2876,
          "y": 0.7652
        }
      }
    ]
  },
  "ProForce 1500XP/1200XP (Page 1)": {
    "catalog_page": 37,
    "image_asset": "schematic-37.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1",
        "part_number": "104267",
        "name": "Phillips Screw, 4mm x 12mm for Lower Air Duct",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3682,
          "y": 0.2475
        }
      },
      {
        "callout": "2",
        "part_number": "104260",
        "name": "Upper Right Wand Guide",
        "in_netsuite": true,
        "handle": "proteam-104260-guide-wand-upper-right",
        "coord": {
          "x": 0.3627,
          "y": 0.2845
        }
      },
      {
        "callout": "3",
        "part_number": "104261",
        "name": "Upper Left Wand Guide",
        "in_netsuite": true,
        "handle": "proteam-104261-guide-wand-upper-left",
        "coord": {
          "x": 0.4673,
          "y": 0.2483
        }
      },
      {
        "callout": "4",
        "part_number": "104263",
        "name": "Wand Lockout Switch",
        "in_netsuite": true,
        "handle": "proteam-104263-switch-wand-lockout",
        "coord": {
          "x": 0.3638,
          "y": 0.3409
        }
      },
      {
        "callout": "5",
        "part_number": "107255",
        "name": "Bulkhead",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4368,
          "y": 0.3678
        }
      },
      {
        "callout": "6",
        "part_number": "104253",
        "name": "Lower Air Duct Seal",
        "in_netsuite": true,
        "handle": "proteam-104253-seal-lower-air-duct-nitrile",
        "coord": {
          "x": 0.4673,
          "y": 0.5741
        }
      },
      {
        "callout": "7",
        "part_number": "104250",
        "name": "Air Duct",
        "in_netsuite": true,
        "handle": "proteam-104250-air-duct",
        "coord": {
          "x": 0.4597,
          "y": 0.6221
        }
      },
      {
        "callout": "8",
        "part_number": "107257",
        "name": "Motor Housing",
        "in_netsuite": true,
        "handle": "proteam-107257-proforce-1500xp-hepa-motor-housing-charcoal-new-style-vacs",
        "coord": {
          "x": 0.207,
          "y": 0.4184
        }
      },
      {
        "callout": "9",
        "part_number": "104504",
        "name": "Pivot Bearing",
        "in_netsuite": true,
        "handle": "proteam-104504-proforce-pivot-bearing",
        "coord": {
          "x": 0.2418,
          "y": 0.5051
        }
      },
      {
        "callout": "10",
        "part_number": "104306",
        "name": "Rear Wheel",
        "in_netsuite": true,
        "handle": "proteam-104306-rear-wheels-for-15-15xp-1500-1500xp-upright-vacuums",
        "coord": {
          "x": 0.3551,
          "y": 0.5076
        }
      },
      {
        "callout": "11",
        "part_number": "107005",
        "name": "Exhaust Filter made from HEPA Media",
        "in_netsuite": true,
        "handle": "proteam-107005-proteam-replacement-hepa-filter",
        "coord": {
          "x": 0.122,
          "y": 0.463
        }
      },
      {
        "callout": "12",
        "part_number": "107258",
        "name": "Filter Cartridge Cover",
        "in_netsuite": true,
        "handle": "proteam-107258-1500xp-hepa-filter-cover",
        "coord": {
          "x": 0.1569,
          "y": 0.5236
        }
      },
      {
        "callout": "13",
        "part_number": "103532",
        "name": "Front Panel Motor Housing Sound Foam",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1721,
          "y": 0.3418
        }
      },
      {
        "callout": "14",
        "part_number": "103533",
        "name": "Left Panel Motor Housing Sound Foam",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1634,
          "y": 0.3114
        }
      },
      {
        "callout": "15",
        "part_number": "103531",
        "name": "Rear Panel Motor Housing Sound Foam",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3072,
          "y": 0.3266
        }
      },
      {
        "callout": "16",
        "part_number": "104247",
        "name": "Lower Motor Mount",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1961,
          "y": 0.2635
        }
      },
      {
        "callout": "17",
        "part_number": "104249",
        "name": "Upper Motor Mount",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1645,
          "y": 0.1498
        }
      },
      {
        "callout": "18",
        "part_number": "104957",
        "name": "Motor Assembly w/Jumpers (includes: A, B) 1 kit 119.33",
        "in_netsuite": true,
        "handle": "proteam-104957-suction-motor-assembly-w-jumpers-for-procare-proforce",
        "coord": {
          "x": 0.146,
          "y": 0.1818
        }
      },
      {
        "callout": "19",
        "part_number": "105488",
        "name": "Motor Housing Sound Filter (includes: 13,14,15) 1 kit 27.87",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1612,
          "y": 0.2744
        }
      },
      {
        "callout": "20",
        "part_number": "105490",
        "name": "Wand Kit (includes: 1, 2, 3, 4) 1 kit 23.36",
        "in_netsuite": true,
        "handle": "proteam-105490-wand-kit-for-upright",
        "coord": {
          "x": 0.4891,
          "y": 0.303
        }
      },
      {
        "callout": "21",
        "part_number": "105489",
        "name": "Air Duct Kit (includes: 1, 6, 7) 1 kit 20.94",
        "in_netsuite": true,
        "handle": "proteam-105489-air-duct-kit",
        "coord": {
          "x": 0.378,
          "y": 0.6667
        }
      },
      {
        "callout": "22",
        "part_number": "107282",
        "name": "ProForce 1500XP Power Nozzle Cover with",
        "in_netsuite": true,
        "handle": "proteam-107282-proforce-1500xp-hepa-upright-power-nozzle-cover-with-detent-springs-decal",
        "coord": {
          "x": 0.2102,
          "y": 0.5194
        }
      },
      {
        "callout": null,
        "part_number": "107283",
        "name": "ProForce 1200XP Power Nozzle Cover with",
        "in_netsuite": true,
        "handle": "proteam-107283-proforce-1200xp-hepa-power-nozzle-cover-with-detent-springs-decal",
        "coord": null
      },
      {
        "callout": "23",
        "part_number": "104279",
        "name": "Power Nozzle Lockout Safety Switch",
        "in_netsuite": true,
        "handle": "proteam-104279-switch-safty-power-nozzle-lockout",
        "coord": {
          "x": 0.1678,
          "y": 0.6313
        }
      },
      {
        "callout": "24",
        "part_number": "104212",
        "name": "Circuit Breaker (reset button)",
        "in_netsuite": true,
        "handle": "proteam-104212-circuit-breaker",
        "coord": {
          "x": 0.1285,
          "y": 0.6448
        }
      },
      {
        "callout": "25",
        "part_number": "104496",
        "name": "Phillips Screw, 3.5mm x 13mm, for Brush Retainer4/pk 9.70",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1307,
          "y": 0.665
        }
      },
      {
        "callout": "26",
        "part_number": "104499",
        "name": "Brush Roll Retainer",
        "in_netsuite": true,
        "handle": "proteam-104499-brush-roll-retainer",
        "coord": {
          "x": 0.1013,
          "y": 0.6886
        }
      },
      {
        "callout": "27",
        "part_number": "104216",
        "name": "14\" Power Nozzle Brush Roll for",
        "in_netsuite": true,
        "handle": "proteam-104216-proforce-1500-1500xp-brush-roll",
        "coord": {
          "x": 0.1122,
          "y": 0.7146
        }
      },
      {
        "callout": "28",
        "part_number": "104218",
        "name": "ProForce 1500XP Vinyl Power Nozzle Bumper",
        "in_netsuite": true,
        "handle": "proteam-104218-bumper-1500xp",
        "coord": {
          "x": 0.1013,
          "y": 0.7458
        }
      },
      {
        "callout": null,
        "part_number": "107166",
        "name": "ProForce 1200XP Vinyl Power Nozzle Bumper",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "29",
        "part_number": "104500",
        "name": "Formed Wire Brace for Power Nozzle Base",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1765,
          "y": 0.8072
        }
      },
      {
        "callout": "30",
        "part_number": "104221",
        "name": "ProForce 1500XP Power Nozzle Baseplate",
        "in_netsuite": true,
        "handle": "proteam-104221-baseplate-for-proforce-upright-vacuum",
        "coord": {
          "x": 0.1416,
          "y": 0.8392
        }
      },
      {
        "callout": null,
        "part_number": "107167",
        "name": "ProForce 1200XP Power Nozzle Baseplate",
        "in_netsuite": true,
        "handle": "proteam-107167-proforce-1200xp-power-nozzle-baseplate",
        "coord": null
      },
      {
        "callout": "31",
        "part_number": "104497",
        "name": "Phillips Screw, 4mm x 35mm for Base Cover",
        "in_netsuite": true,
        "handle": "proteam-104497-screw-phillips-4mm-x-35mm-f-base-cover-8pk",
        "coord": {
          "x": 0.1547,
          "y": 0.8948
        }
      },
      {
        "callout": "32",
        "part_number": "834363",
        "name": "Wheel/Axle Replacement Kit 1 kit 13.12",
        "in_netsuite": true,
        "handle": "proteam-834363-wheel-axle-replacement-kit",
        "coord": {
          "x": 0.3105,
          "y": 0.9226
        }
      },
      {
        "callout": "33",
        "part_number": "104503",
        "name": "Rear Wheel Clamp",
        "in_netsuite": true,
        "handle": "proteam-104503-rear-wheel-clamp",
        "coord": {
          "x": 0.354,
          "y": 0.8333
        }
      },
      {
        "callout": "34",
        "part_number": "104495",
        "name": "Phillips Screw, 4mm x 19mm for Powerhead",
        "in_netsuite": true,
        "handle": "proteam-104495-phillips-screw-4mm-x-19mm-for-powerhead",
        "coord": {
          "x": 0.3083,
          "y": 0.7997
        }
      },
      {
        "callout": "35",
        "part_number": "104227",
        "name": "Air Duct Hose Sleeve",
        "in_netsuite": true,
        "handle": "proteam-104227-sleeve-hose-airduct",
        "coord": {
          "x": 0.3322,
          "y": 0.7862
        }
      },
      {
        "callout": "36",
        "part_number": "104230",
        "name": "Power Nozzle to Air Duct Lower Hose",
        "in_netsuite": true,
        "handle": "proteam-104230-upright-power-nozzle-hose",
        "coord": {
          "x": 0.3813,
          "y": 0.7668
        }
      },
      {
        "callout": "37",
        "part_number": "104217",
        "name": "Brush Roll Drive Belt",
        "in_netsuite": true,
        "handle": "proteam-104217-upright-vacuum-belts",
        "coord": {
          "x": 0.3246,
          "y": 0.7458
        }
      },
      {
        "callout": "38",
        "part_number": "104506",
        "name": "Power Nozzle Motor with Crimps",
        "in_netsuite": true,
        "handle": "proteam-104506-upright-vacuum-motor",
        "coord": {
          "x": 0.1983,
          "y": 0.7138
        }
      },
      {
        "callout": "39",
        "part_number": "104498",
        "name": "Power Nozzle Motor Vibration Grommet",
        "in_netsuite": true,
        "handle": "proteam-104498-grommet-vibration-power-nozzle-motor-nitrile",
        "coord": {
          "x": 0.2996,
          "y": 0.7214
        }
      },
      {
        "callout": "40",
        "part_number": "104224",
        "name": "Power Nozzle Air Duct Cover",
        "in_netsuite": true,
        "handle": "proteam-104224-cover-air-duct-power-nozzle",
        "coord": {
          "x": 0.1852,
          "y": 0.6919
        }
      },
      {
        "callout": "41",
        "part_number": "104226",
        "name": "Vacuum Operation Indicator Board",
        "in_netsuite": true,
        "handle": "proteam-104226-board-vacuum-operation-indicator",
        "coord": {
          "x": 0.268,
          "y": 0.6515
        }
      },
      {
        "callout": "42",
        "part_number": "104507",
        "name": "Detent Upright Lock Spring",
        "in_netsuite": true,
        "handle": "proteam-104507-spring-detent-uright-lock",
        "coord": {
          "x": 0.3508,
          "y": 0.5488
        }
      },
      {
        "callout": "43",
        "part_number": "105371",
        "name": "Phillips Screw, 4.2mm x 19mm, for Power",
        "in_netsuite": true,
        "handle": "proteam-105371-phillips-screw-4-2mm-x-19mm-for-power-nozzle-motor",
        "coord": {
          "x": 0.2985,
          "y": 0.7012
        }
      },
      {
        "callout": "44",
        "part_number": "105281",
        "name": "Carbon Brush Set for ProForce Motor",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1351,
          "y": 0.2104
        }
      },
      {
        "callout": null,
        "part_number": "105754",
        "name": "Wire Harness Kit includes:",
        "in_netsuite": true,
        "handle": "proteam-105754-wire-harness-kit",
        "coord": null
      }
    ]
  },
  "ProForce 1500XP/1200XP (Page 2)": {
    "catalog_page": 38,
    "image_asset": "schematic-38.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1",
        "part_number": "104234",
        "name": "Grey Bag Housing Cover",
        "in_netsuite": true,
        "handle": "proteam-104234-bag-cover-housing-for-proforce-1500xp",
        "coord": {
          "x": 0.1558,
          "y": 0.2239
        }
      },
      {
        "callout": "2",
        "part_number": "104232",
        "name": "Bag Cover Release Latch",
        "in_netsuite": true,
        "handle": "proteam-103232-latch-release-bag-cover",
        "coord": {
          "x": 0.2135,
          "y": 0.1574
        }
      },
      {
        "callout": "3",
        "part_number": "104233",
        "name": "Release Latch Button Spring for Bag Cover",
        "in_netsuite": true,
        "handle": "proteam-104233-spring-release-button-f-bag-cover-latch",
        "coord": {
          "x": 0.2277,
          "y": 0.1768
        }
      },
      {
        "callout": "4",
        "part_number": "104235",
        "name": "Upper Seal Transition Duct for Bag Cover",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1688,
          "y": 0.2778
        }
      },
      {
        "callout": "5",
        "part_number": "104236",
        "name": "Transition Duct Bag Cover",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1688,
          "y": 0.3022
        }
      },
      {
        "callout": "6",
        "part_number": "104238",
        "name": "Lower Seal Transition Duct Bag Cover Nozzle Plate1 ea. 4.29",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1841,
          "y": 0.3561
        }
      },
      {
        "callout": "7",
        "part_number": "104239",
        "name": "Bag Cover Nozzle Plate",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1634,
          "y": 0.3923
        }
      },
      {
        "callout": "8",
        "part_number": "104242",
        "name": "Bag Cover Latch Spring",
        "in_netsuite": true,
        "handle": "proteam-104242-spring-bag-cover-latch",
        "coord": {
          "x": 0.3257,
          "y": 0.3577
        }
      },
      {
        "callout": "9",
        "part_number": "104243",
        "name": "Bag Cover Latch Plate",
        "in_netsuite": true,
        "handle": "proteam-104243-plate-bag-cover-latch",
        "coord": {
          "x": 0.3834,
          "y": 0.3047
        }
      },
      {
        "callout": "10",
        "part_number": "104505",
        "name": "Phillips Screw, 4mm x 9.5mm",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1732,
          "y": 0.3258
        }
      },
      {
        "callout": "11",
        "part_number": "104241",
        "name": "Bag Cover Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1721,
          "y": 0.4293
        }
      },
      {
        "callout": "12",
        "part_number": "104493",
        "name": "Phillips Screw, 4.2mm x 35mm",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1765,
          "y": 0.4697
        }
      },
      {
        "callout": "13",
        "part_number": "105486",
        "name": "Filter Cover Kit w/Riveted Hinge and 6 Rivets 1 kit 83.54",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4641,
          "y": 0.3215
        }
      },
      {
        "callout": "14",
        "part_number": "107260",
        "name": "ProForce 1500XP Bag Housing Assembly with",
        "in_netsuite": true,
        "handle": "proteam-107260-proforce-1500xp-hepa-bag-housing",
        "coord": {
          "x": 0.1155,
          "y": 0.8931
        }
      },
      {
        "callout": null,
        "part_number": "107285",
        "name": "ProForce 1200XP Bag Housing Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": null
      },
      {
        "callout": "15",
        "part_number": "104491",
        "name": "Rivet for Bag Housing Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2451,
          "y": 0.8923
        }
      },
      {
        "callout": "16",
        "part_number": "104284",
        "name": "50' Yellow Power Cord with Strain Relief",
        "in_netsuite": true,
        "handle": "proteam-104284-50-yellow-power-cord-with-strain-relief",
        "coord": {
          "x": 0.4597,
          "y": 0.8232
        }
      },
      {
        "callout": "17",
        "part_number": "103483",
        "name": "Intercept Micro Filter",
        "in_netsuite": true,
        "handle": "proteam-103483-upright-vacuum-bags",
        "coord": {
          "x": 0.1068,
          "y": 0.6709
        }
      },
      {
        "callout": "18",
        "part_number": "104738",
        "name": "Bag Housing Gasket Seal",
        "in_netsuite": true,
        "handle": "proteam-104738-bad-housing-gasket-seal",
        "coord": {
          "x": 0.1013,
          "y": 0.7433
        }
      },
      {
        "callout": "19",
        "part_number": "104283",
        "name": "Lock-Out Filter Switch",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2277,
          "y": 0.8072
        }
      },
      {
        "callout": "20",
        "part_number": "104281",
        "name": "Double Layer Motor Intake Filter",
        "in_netsuite": true,
        "handle": "proteam-104281-proforce-motor-intake-filter",
        "coord": {
          "x": 0.0991,
          "y": 0.7618
        }
      },
      {
        "callout": "21",
        "part_number": "104282",
        "name": "Lock-Out Filter Switch Cover",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2288,
          "y": 0.7753
        }
      },
      {
        "callout": "22",
        "part_number": "104268",
        "name": "Cord Wrap Bracket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3431,
          "y": 0.638
        }
      },
      {
        "callout": "23",
        "part_number": "104269",
        "name": "Cord Wrap Compression Bracket Spring",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3257,
          "y": 0.6566
        }
      },
      {
        "callout": "24",
        "part_number": "104270",
        "name": "Cord Wrap Bracket Compression Spring Washer",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3028,
          "y": 0.5943
        }
      },
      {
        "callout": "25",
        "part_number": "105147",
        "name": "On/Off Rocker Switch",
        "in_netsuite": true,
        "handle": "proteam-105147-upright-vacuum-switch",
        "coord": {
          "x": 0.1939,
          "y": 0.5463
        }
      },
      {
        "callout": "26",
        "part_number": "104264",
        "name": "Handle Tube Bushing",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2789,
          "y": 0.8232
        }
      },
      {
        "callout": "27",
        "part_number": "104259",
        "name": "Handle Nut Plate",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1209,
          "y": 0.7862
        }
      },
      {
        "callout": "28",
        "part_number": "107256",
        "name": "Carry Handle with Tool Caddy",
        "in_netsuite": true,
        "handle": "proteam-107256-carry-handle-with-tool-caddy-proforce",
        "coord": {
          "x": 0.2996,
          "y": 0.729
        }
      },
      {
        "callout": "29",
        "part_number": "104294",
        "name": "Wand",
        "in_netsuite": true,
        "handle": "proteam-104294-wand-for-xp-upright-vacuum",
        "coord": {
          "x": 0.4423,
          "y": 0.7433
        }
      },
      {
        "callout": "30",
        "part_number": "105091",
        "name": "Strain Relief Kit with Fastener Clip (includes: 43)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3497,
          "y": 0.7441
        }
      },
      {
        "callout": "31",
        "part_number": "104271",
        "name": "Phillips Head Screw for Cord Wrap, M4 x 45mm",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3508,
          "y": 0.5833
        }
      },
      {
        "callout": "32",
        "part_number": "104509",
        "name": "Phillips Screw, 4mm x 16mm x .07 Pitch,",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3028,
          "y": 0.6709
        }
      },
      {
        "callout": "33",
        "part_number": "105075",
        "name": "Phillips Screw, 2.9mm x 13mm, for Switch Cover",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1481,
          "y": 0.7955
        }
      },
      {
        "callout": "34",
        "part_number": "104266",
        "name": "Handle Assembly Screw",
        "in_netsuite": true,
        "handle": "proteam-104266-screw-for-handle-assembly",
        "coord": {
          "x": 0.3355,
          "y": 0.8098
        }
      },
      {
        "callout": "35",
        "part_number": "104493",
        "name": "Phillips Screw, 4.2mm x 35mm",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.0871,
          "y": 0.8241
        }
      },
      {
        "callout": "36",
        "part_number": "106618",
        "name": "Tube Handle Assembly Complete",
        "in_netsuite": true,
        "handle": "proteam-106618-handle-and-tube-assembly-complete",
        "coord": {
          "x": 0.3279,
          "y": 0.5253
        }
      },
      {
        "callout": "37",
        "part_number": "104961",
        "name": "Hose Assembly with Cuffs (includes: 39)",
        "in_netsuite": true,
        "handle": "proteam-104961-upright-vacuum-hose-assembly-w-cuffs",
        "coord": {
          "x": 0.4466,
          "y": 0.5505
        }
      },
      {
        "callout": "38",
        "part_number": "106617",
        "name": "Handle Kit (includes: 22-25, 31, 32, 40-42) 1 kit 75.95",
        "in_netsuite": true,
        "handle": "proteam-106617-proforce-handle-kit",
        "coord": {
          "x": 0.4009,
          "y": 0.5471
        }
      },
      {
        "callout": "39",
        "part_number": "105573",
        "name": "Quick Release Hose Cuff",
        "in_netsuite": true,
        "handle": "proteam-105573-quick-release-hose-cuff",
        "coord": {
          "x": 0.4346,
          "y": 0.7029
        }
      },
      {
        "callout": "40",
        "part_number": "107093",
        "name": "Impact Bumper",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.329,
          "y": 0.5808
        }
      },
      {
        "callout": "41",
        "part_number": "106619",
        "name": "Handle/Bezel Assembly (includes: 42)",
        "in_netsuite": true,
        "handle": "proteam-106619-handle-bezel-for-proforce-1500xp",
        "coord": {
          "x": 0.1601,
          "y": 0.5825
        }
      },
      {
        "callout": "42",
        "part_number": "106739",
        "name": "Handle Bezel",
        "in_netsuite": true,
        "handle": "proteam-106739-handle-bezel",
        "coord": {
          "x": 0.1983,
          "y": 0.6313
        }
      },
      {
        "callout": "43",
        "part_number": "105320",
        "name": "Fastener",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3682,
          "y": 0.7323
        }
      },
      {
        "callout": "44",
        "part_number": "107203",
        "name": "Cord Retention Clip",
        "in_netsuite": true,
        "handle": "proteam-107203-cord-retention-clip",
        "coord": {
          "x": 0.3638,
          "y": 0.7988
        }
      }
    ]
  },
  "ProBlitz AirMover / ProGuard 4 Portable": {
    "catalog_page": 39,
    "image_asset": "schematic-39.jpeg",
    "type": "dual",
    "machine_boundary": 17,
    "sections": [
      {
        "name": "ProGuard 4 Portable",
        "callout_coords": {
          "1": {
            "x": 0.092,
            "y": 0.532
          },
          "2": {
            "x": 0.108,
            "y": 0.555
          },
          "3": {
            "x": 0.078,
            "y": 0.578
          },
          "4": {
            "x": 0.095,
            "y": 0.602
          },
          "5": {
            "x": 0.13,
            "y": 0.625
          },
          "6": {
            "x": 0.148,
            "y": 0.648
          },
          "7": {
            "x": 0.132,
            "y": 0.672
          },
          "8": {
            "x": 0.112,
            "y": 0.695
          },
          "9": {
            "x": 0.095,
            "y": 0.718
          },
          "10": {
            "x": 0.075,
            "y": 0.742
          },
          "11": {
            "x": 0.092,
            "y": 0.765
          },
          "12": {
            "x": 0.108,
            "y": 0.788
          },
          "13": {
            "x": 0.128,
            "y": 0.812
          },
          "14": {
            "x": 0.145,
            "y": 0.835
          },
          "15": {
            "x": 0.162,
            "y": 0.858
          },
          "16": {
            "x": 0.148,
            "y": 0.882
          },
          "17": {
            "x": 0.128,
            "y": 0.905
          }
        }
      },
      {
        "name": "ProBlitz AirMover",
        "callout_coords": {
          "1": {
            "x": 0.095,
            "y": 0.108
          },
          "2": {
            "x": 0.145,
            "y": 0.092
          },
          "3": {
            "x": 0.172,
            "y": 0.115
          },
          "4": {
            "x": 0.192,
            "y": 0.138
          },
          "5": {
            "x": 0.205,
            "y": 0.162
          },
          "6": {
            "x": 0.215,
            "y": 0.188
          },
          "7": {
            "x": 0.205,
            "y": 0.215
          },
          "8": {
            "x": 0.188,
            "y": 0.238
          },
          "9": {
            "x": 0.168,
            "y": 0.262
          },
          "10": {
            "x": 0.145,
            "y": 0.278
          },
          "11": {
            "x": 0.122,
            "y": 0.298
          },
          "12": {
            "x": 0.148,
            "y": 0.198
          },
          "13": {
            "x": 0.092,
            "y": 0.275
          },
          "14": {
            "x": 0.115,
            "y": 0.218
          },
          "15": {
            "x": 0.075,
            "y": 0.235
          },
          "16": {
            "x": 0.068,
            "y": 0.258
          },
          "17": {
            "x": 0.095,
            "y": 0.308
          },
          "18": {
            "x": 0.185,
            "y": 0.308
          }
        }
      }
    ],
    "parts": [
      {
        "callout": "1",
        "part_number": "510224",
        "name": "Switch and Switch Cover",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2168,
          "y": 0.5724
        },
        "machine_section": 0
      },
      {
        "callout": "2",
        "part_number": "510225",
        "name": "Motor Cover and Top Handle",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2211,
          "y": 0.6002
        },
        "machine_section": 0
      },
      {
        "callout": "3",
        "part_number": "829719-4",
        "name": "Cord Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1035,
          "y": 0.6751
        },
        "machine_section": 0
      },
      {
        "callout": "4",
        "part_number": "830519",
        "name": "Exhaust Duct",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.22,
          "y": 0.6768
        },
        "machine_section": 0
      },
      {
        "callout": "5",
        "part_number": "509776-19",
        "name": "Motor Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2146,
          "y": 0.7113
        },
        "machine_section": 0
      },
      {
        "callout": "6",
        "part_number": "842668-2",
        "name": "Lid",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.0784,
          "y": 0.7551
        },
        "machine_section": 0
      },
      {
        "callout": "7",
        "part_number": "826387",
        "name": "Tank Latch",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.0664,
          "y": 0.7811
        },
        "machine_section": 0
      },
      {
        "callout": "8",
        "part_number": "510124",
        "name": "Blower Wheel, Washer, Spacer, Nut",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1514,
          "y": 0.83
        },
        "machine_section": 0
      },
      {
        "callout": "9",
        "part_number": "832656-1",
        "name": "Plate Collector",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.0763,
          "y": 0.8434
        },
        "machine_section": 0
      },
      {
        "callout": "10",
        "part_number": "820563-4",
        "name": "Screw, Type AB #10 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.0632,
          "y": 0.9015
        },
        "machine_section": 0
      },
      {
        "callout": "11",
        "part_number": "510108",
        "name": "Filter Cage and Float Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2462,
          "y": 0.8316
        },
        "machine_section": 0
      },
      {
        "callout": "12",
        "part_number": "107178",
        "name": "Qwik Lock Fine Dust Cartridge Filter",
        "in_netsuite": true,
        "handle": "proteam-107178-qwik-lock-fine-dust-cartridge-filter-fits-proguard-3-4-gal",
        "coord": {
          "x": 0.2571,
          "y": 0.8864
        },
        "machine_section": 0
      },
      {
        "callout": "13",
        "part_number": "510106",
        "name": "Tank (with Inlet)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2865,
          "y": 0.7845
        },
        "machine_section": 0
      },
      {
        "callout": "14",
        "part_number": "510109",
        "name": "Casters",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4869,
          "y": 0.8468
        },
        "machine_section": 0
      },
      {
        "callout": "15",
        "part_number": "831337-6",
        "name": "Premium Hose Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4466,
          "y": 0.6818
        },
        "machine_section": 0
      },
      {
        "callout": "16",
        "part_number": "830098",
        "name": "Diffuser",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3802,
          "y": 0.6305
        },
        "machine_section": 0
      },
      {
        "callout": "17",
        "part_number": "107182",
        "name": "Intercept Micro Filter Bag (optional)",
        "in_netsuite": true,
        "handle": "proteam-107182-intercept-micro-filter-3-pack",
        "coord": {
          "x": 0.4902,
          "y": 0.6532
        },
        "machine_section": 0
      },
      {
        "callout": "1",
        "part_number": "510141",
        "name": "Switch & Knob Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1068,
          "y": 0.1305
        },
        "machine_section": 1
      },
      {
        "callout": "2",
        "part_number": "833658",
        "name": "Inlet Grill",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1013,
          "y": 0.2037
        },
        "machine_section": 1
      },
      {
        "callout": null,
        "part_number": "510551",
        "name": "Inlet Grill with Outlets (ProBlitz XP)",
        "in_netsuite": false,
        "handle": null,
        "coord": null,
        "machine_section": 1
      },
      {
        "callout": "3",
        "part_number": "820563-7",
        "name": "Screw, Type AB #10 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1852,
          "y": 0.1465
        },
        "machine_section": 1
      },
      {
        "callout": "4",
        "part_number": "833673",
        "name": "Threaded Inserts - Housing",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.219,
          "y": 0.1229
        },
        "machine_section": 1
      },
      {
        "callout": "5",
        "part_number": "820563-7",
        "name": "Screw, Type AB #10 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3028,
          "y": 0.1456
        },
        "machine_section": 1
      },
      {
        "callout": "6",
        "part_number": "820563-13",
        "name": "Screw, Type AB #10 x 1\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1405,
          "y": 0.2475
        },
        "machine_section": 1
      },
      {
        "callout": "7",
        "part_number": "510140",
        "name": "Wheel Assembly (ProBlitz XP)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1176,
          "y": 0.2441
        },
        "machine_section": 1
      },
      {
        "callout": "8",
        "part_number": "820563-7",
        "name": "Screw, Type AB #10 x ¾\" (ProBlitz XP)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2037,
          "y": 0.2694
        },
        "machine_section": 1
      },
      {
        "callout": "9",
        "part_number": "833690",
        "name": "Foot Bumper",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2386,
          "y": 0.2719
        },
        "machine_section": 1
      },
      {
        "callout": "10",
        "part_number": "820563-7",
        "name": "Screw, Type AB #10 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4564,
          "y": 0.25
        },
        "machine_section": 1
      },
      {
        "callout": "11",
        "part_number": "833659",
        "name": "Exhaust Grill",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3551,
          "y": 0.165
        },
        "machine_section": 1
      },
      {
        "callout": "12",
        "part_number": "833674",
        "name": "Motor",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3813,
          "y": 0.1288
        },
        "machine_section": 1
      },
      {
        "callout": "13",
        "part_number": "833675",
        "name": "30' Cord w/Plug",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4259,
          "y": 0.133
        },
        "machine_section": 1
      },
      {
        "callout": "14",
        "part_number": "833660",
        "name": "Blower Wheel",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2157,
          "y": 0.2912
        },
        "machine_section": 1
      },
      {
        "callout": "15",
        "part_number": "833691",
        "name": "Retractable Handle (ProBlitz XP)",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1275,
          "y": 0.3215
        },
        "machine_section": 1
      },
      {
        "callout": "16",
        "part_number": "820563-7",
        "name": "Screw, Type AB #10 x ¾\" (ProBlitz XP)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3159,
          "y": 0.2685
        },
        "machine_section": 1
      },
      {
        "callout": "17",
        "part_number": "833657-1",
        "name": "Housing (left side)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3126,
          "y": 0.271
        },
        "machine_section": 1
      },
      {
        "callout": "18",
        "part_number": "833656-1",
        "name": "Housing (right side)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.366,
          "y": 0.298
        },
        "machine_section": 1
      }
    ]
  },
  "ProGuard 10 / ProGuard 16 MD": {
    "catalog_page": 40,
    "image_asset": "schematic-40.jpeg",
    "type": "dual",
    "machine_boundary": 38,
    "sections": [
      {
        "name": "ProGuard 10",
        "callout_coords": {
          "1": {
            "x": 0.22,
            "y": 0.11
          },
          "2": {
            "x": 0.34,
            "y": 0.09
          },
          "3": {
            "x": 0.26,
            "y": 0.1
          },
          "4": {
            "x": 0.19,
            "y": 0.125
          },
          "5": {
            "x": 0.3,
            "y": 0.12
          },
          "6": {
            "x": 0.33,
            "y": 0.16
          },
          "7": {
            "x": 0.16,
            "y": 0.17
          },
          "8": {
            "x": 0.33,
            "y": 0.19
          },
          "9": {
            "x": 0.32,
            "y": 0.175
          },
          "10": {
            "x": 0.17,
            "y": 0.2
          },
          "11": {
            "x": 0.1,
            "y": 0.22
          },
          "12": {
            "x": 0.32,
            "y": 0.23
          },
          "13": {
            "x": 0.21,
            "y": 0.235
          },
          "14": {
            "x": 0.3,
            "y": 0.235
          },
          "15": {
            "x": 0.3,
            "y": 0.285
          },
          "16": {
            "x": 0.3,
            "y": 0.3
          },
          "17": {
            "x": 0.27,
            "y": 0.31
          },
          "18": {
            "x": 0.25,
            "y": 0.305
          },
          "19": {
            "x": 0.22,
            "y": 0.4
          },
          "20": {
            "x": 0.33,
            "y": 0.385
          },
          "21": {
            "x": 0.35,
            "y": 0.39
          },
          "22": {
            "x": 0.27,
            "y": 0.39
          },
          "23": {
            "x": 0.25,
            "y": 0.405
          },
          "24": {
            "x": 0.34,
            "y": 0.42
          },
          "25": {
            "x": 0.32,
            "y": 0.44
          },
          "26": {
            "x": 0.29,
            "y": 0.41
          },
          "27": {
            "x": 0.31,
            "y": 0.405
          },
          "28": {
            "x": 0.15,
            "y": 0.4
          },
          "29": {
            "x": 0.21,
            "y": 0.415
          },
          "30": {
            "x": 0.2,
            "y": 0.42
          },
          "31": {
            "x": 0.24,
            "y": 0.41
          },
          "32": {
            "x": 0.32,
            "y": 0.47
          },
          "33": {
            "x": 0.2,
            "y": 0.465
          },
          "34": {
            "x": 0.2,
            "y": 0.49
          },
          "35": {
            "x": 0.35,
            "y": 0.495
          },
          "36": {
            "x": 0.28,
            "y": 0.09
          },
          "37": {
            "x": 0.3,
            "y": 0.09
          },
          "38": {
            "x": 0.32,
            "y": 0.085
          }
        }
      },
      {
        "name": "ProGuard 16 MD",
        "callout_coords": {
          "1": {
            "x": 0.24,
            "y": 0.58
          },
          "2": {
            "x": 0.16,
            "y": 0.6
          },
          "3": {
            "x": 0.22,
            "y": 0.6
          },
          "4": {
            "x": 0.15,
            "y": 0.63
          },
          "5": {
            "x": 0.29,
            "y": 0.61
          },
          "6": {
            "x": 0.2,
            "y": 0.64
          },
          "7": {
            "x": 0.24,
            "y": 0.62
          },
          "8": {
            "x": 0.31,
            "y": 0.64
          },
          "9": {
            "x": 0.3,
            "y": 0.67
          },
          "10": {
            "x": 0.23,
            "y": 0.68
          },
          "11": {
            "x": 0.29,
            "y": 0.68
          },
          "12": {
            "x": 0.12,
            "y": 0.68
          },
          "13": {
            "x": 0.15,
            "y": 0.7
          },
          "14": {
            "x": 0.14,
            "y": 0.72
          },
          "15": {
            "x": 0.16,
            "y": 0.73
          },
          "16": {
            "x": 0.27,
            "y": 0.74
          },
          "17": {
            "x": 0.23,
            "y": 0.74
          },
          "18": {
            "x": 0.16,
            "y": 0.8
          },
          "19": {
            "x": 0.26,
            "y": 0.8
          },
          "20": {
            "x": 0.22,
            "y": 0.8
          },
          "21": {
            "x": 0.14,
            "y": 0.8
          },
          "22": {
            "x": 0.22,
            "y": 0.82
          },
          "23": {
            "x": 0.28,
            "y": 0.82
          },
          "24": {
            "x": 0.33,
            "y": 0.72
          },
          "25": {
            "x": 0.2,
            "y": 0.83
          },
          "26": {
            "x": 0.28,
            "y": 0.84
          },
          "27": {
            "x": 0.16,
            "y": 0.87
          },
          "28": {
            "x": 0.17,
            "y": 0.88
          },
          "29": {
            "x": 0.15,
            "y": 0.89
          },
          "30": {
            "x": 0.17,
            "y": 0.91
          },
          "31": {
            "x": 0.16,
            "y": 0.91
          },
          "32": {
            "x": 0.22,
            "y": 0.93
          },
          "33": {
            "x": 0.21,
            "y": 0.95
          },
          "34": {
            "x": 0.27,
            "y": 0.96
          }
        }
      }
    ],
    "parts": [
      {
        "callout": "1",
        "part_number": "510094",
        "name": "Motor Cover Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2451,
          "y": 0.1145
        },
        "machine_section": 0
      },
      {
        "callout": "2",
        "part_number": "830565-2",
        "name": "Handle Motor Cover",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3377,
          "y": 0.0951
        },
        "machine_section": 0
      },
      {
        "callout": "3",
        "part_number": "820563-4",
        "name": "Screw Type AB #10 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3377,
          "y": 0.1094
        },
        "machine_section": 0
      },
      {
        "callout": "4",
        "part_number": "833600",
        "name": "Diffuser Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2048,
          "y": 0.1347
        },
        "machine_section": 0
      },
      {
        "callout": "5",
        "part_number": "510127",
        "name": "Switch Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3301,
          "y": 0.1246
        },
        "machine_section": 0
      },
      {
        "callout": "6",
        "part_number": "831651",
        "name": "Duct Motor Exhaust/Cooling Fan",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3235,
          "y": 0.1591
        },
        "machine_section": 0
      },
      {
        "callout": "7",
        "part_number": "830609",
        "name": "Exhaust Foam Pad",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1852,
          "y": 0.1717
        },
        "machine_section": 0
      },
      {
        "callout": "8",
        "part_number": "831653-3",
        "name": "Lid with Foam",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3344,
          "y": 0.1944
        },
        "machine_section": 0
      },
      {
        "callout": "9",
        "part_number": "826453-2",
        "name": "Screw 10-32 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3203,
          "y": 0.1818
        },
        "machine_section": 0
      },
      {
        "callout": "10",
        "part_number": "833417",
        "name": "Power Cord Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1863,
          "y": 0.1928
        },
        "machine_section": 0
      },
      {
        "callout": "11",
        "part_number": "822374-8",
        "name": "Carbon Brush Set",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1514,
          "y": 0.2155
        },
        "machine_section": 0
      },
      {
        "callout": "12",
        "part_number": "831567",
        "name": "Motor Assembly Complete",
        "in_netsuite": true,
        "handle": "proteam-831567-motor-assembly-complete-proguard",
        "coord": {
          "x": 0.3322,
          "y": 0.2264
        },
        "machine_section": 0
      },
      {
        "callout": "13",
        "part_number": "833518",
        "name": "Gasket Lid",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2277,
          "y": 0.229
        },
        "machine_section": 0
      },
      {
        "callout": "14",
        "part_number": "827415",
        "name": "Gasket Motor",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3312,
          "y": 0.2424
        },
        "machine_section": 0
      },
      {
        "callout": "15",
        "part_number": "831659",
        "name": "Collector Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3399,
          "y": 0.2702
        },
        "machine_section": 0
      },
      {
        "callout": "16",
        "part_number": "833778",
        "name": "Ball Float",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3235,
          "y": 0.2879
        },
        "machine_section": 0
      },
      {
        "callout": "17",
        "part_number": "830101-1",
        "name": "Filter Cage",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3192,
          "y": 0.3039
        },
        "machine_section": 0
      },
      {
        "callout": "18",
        "part_number": "107177",
        "name": "Wet Filter",
        "in_netsuite": true,
        "handle": "proteam-107177-qwik-lock-wet-filter-fits-proguard-10-20-gal",
        "coord": {
          "x": 0.2505,
          "y": 0.33
        },
        "machine_section": 0
      },
      {
        "callout": "19",
        "part_number": "833601",
        "name": "Tank, 10 Gallon",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2375,
          "y": 0.3838
        },
        "machine_section": 0
      },
      {
        "callout": "20",
        "part_number": "833424-1",
        "name": "Drum Latch",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.354,
          "y": 0.3586
        },
        "machine_section": 0
      },
      {
        "callout": "21",
        "part_number": "833492-1",
        "name": "Screw 10-32 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3682,
          "y": 0.3653
        },
        "machine_section": 0
      },
      {
        "callout": "22",
        "part_number": "833493",
        "name": "Washer (13/64 ID) #10",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2952,
          "y": 0.3687
        },
        "machine_section": 0
      },
      {
        "callout": "23",
        "part_number": "161255-8",
        "name": "Nut Lock #10",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2865,
          "y": 0.3754
        },
        "machine_section": 0
      },
      {
        "callout": "24",
        "part_number": "833425",
        "name": "Tank Inlet Adapter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3595,
          "y": 0.4108
        },
        "machine_section": 0
      },
      {
        "callout": "25",
        "part_number": "833426",
        "name": "Gasket Inlet Adapter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3431,
          "y": 0.399
        },
        "machine_section": 0
      },
      {
        "callout": "26",
        "part_number": "833492",
        "name": "Screw 1-32 x 1 ¼\"",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3562,
          "y": 0.4301
        },
        "machine_section": 0
      },
      {
        "callout": "27",
        "part_number": "833493",
        "name": "Washer (13/64 ID) #10",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3388,
          "y": 0.3914
        },
        "machine_section": 0
      },
      {
        "callout": "28",
        "part_number": "73185",
        "name": "Drain Cap",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1863,
          "y": 0.3855
        },
        "machine_section": 0
      },
      {
        "callout": "29",
        "part_number": "833429",
        "name": "Drain Adapter with Gasket",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1895,
          "y": 0.4318
        },
        "machine_section": 0
      },
      {
        "callout": "30",
        "part_number": "833492-2",
        "name": "Screw 1-32 x 1 3/8\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1776,
          "y": 0.4251
        },
        "machine_section": 0
      },
      {
        "callout": "31",
        "part_number": "833493",
        "name": "Washer (13/64 ID) #10",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2266,
          "y": 0.3948
        },
        "machine_section": 0
      },
      {
        "callout": "32",
        "part_number": "833431",
        "name": "Caster 3\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3333,
          "y": 0.4537
        },
        "machine_section": 0
      },
      {
        "callout": "33",
        "part_number": "833432",
        "name": "50' Extension Cord",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2266,
          "y": 0.4604
        },
        "machine_section": 0
      },
      {
        "callout": "34",
        "part_number": "107181",
        "name": "Intercept Micro Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2037,
          "y": 0.4832
        },
        "machine_section": 0
      },
      {
        "callout": "35",
        "part_number": "107175",
        "name": "Qwik Lock Fine Dust Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3377,
          "y": 0.4966
        },
        "machine_section": 0
      },
      {
        "callout": "36",
        "part_number": "831577",
        "name": "Swivel Hose Cuff",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3824,
          "y": 0.4806
        },
        "machine_section": 0
      },
      {
        "callout": "37",
        "part_number": "107198",
        "name": "Hose Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4205,
          "y": 0.4781
        },
        "machine_section": 0
      },
      {
        "callout": "38",
        "part_number": "833587",
        "name": "Locking Ring Cuff",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4412,
          "y": 0.4941
        },
        "machine_section": 0
      },
      {
        "callout": "1",
        "part_number": "830565-2",
        "name": "Handle Motor Cover",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2996,
          "y": 0.612
        },
        "machine_section": 1
      },
      {
        "callout": "2",
        "part_number": "831577",
        "name": "Swivel Hose Cuff",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1558,
          "y": 0.633
        },
        "machine_section": 1
      },
      {
        "callout": "3",
        "part_number": "831337-6",
        "name": "Hose Assembly w/Cuffs",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1743,
          "y": 0.6019
        },
        "machine_section": 1
      },
      {
        "callout": "4",
        "part_number": "829900",
        "name": "Locking Ring Cuff",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2462,
          "y": 0.6044
        },
        "machine_section": 1
      },
      {
        "callout": "5",
        "part_number": "820563-4",
        "name": "Screw Type AB #10 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2712,
          "y": 0.6347
        },
        "machine_section": 1
      },
      {
        "callout": "6",
        "part_number": "510127",
        "name": "Switch Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2244,
          "y": 0.6322
        },
        "machine_section": 1
      },
      {
        "callout": "7",
        "part_number": "833600",
        "name": "Diffuser Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1688,
          "y": 0.6406
        },
        "machine_section": 1
      },
      {
        "callout": "8",
        "part_number": "510286",
        "name": "Motor Cover Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2963,
          "y": 0.6641
        },
        "machine_section": 1
      },
      {
        "callout": "9",
        "part_number": "826387",
        "name": "Drum Latch",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3072,
          "y": 0.7054
        },
        "machine_section": 1
      },
      {
        "callout": "10",
        "part_number": "831651",
        "name": "Duct Motor Exhaust/Cooling Fan",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2756,
          "y": 0.713
        },
        "machine_section": 1
      },
      {
        "callout": "11",
        "part_number": "827415",
        "name": "Gasket Motor",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.28,
          "y": 0.7247
        },
        "machine_section": 1
      },
      {
        "callout": "12",
        "part_number": "831567",
        "name": "Motor Assembly Complete",
        "in_netsuite": true,
        "handle": "proteam-831567-motor-assembly-complete-proguard",
        "coord": {
          "x": 0.2778,
          "y": 0.7374
        },
        "machine_section": 1
      },
      {
        "callout": "13",
        "part_number": "831657-1",
        "name": "Power Cord Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1819,
          "y": 0.7037
        },
        "machine_section": 1
      },
      {
        "callout": "14",
        "part_number": "822374-8",
        "name": "Carbon Brush Set",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1754,
          "y": 0.7197
        },
        "machine_section": 1
      },
      {
        "callout": "15",
        "part_number": "830609",
        "name": "Exhaust Foam Pad",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1623,
          "y": 0.7433
        },
        "machine_section": 1
      },
      {
        "callout": "16",
        "part_number": "831653-1",
        "name": "Lid",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1743,
          "y": 0.7887
        },
        "machine_section": 1
      },
      {
        "callout": "17",
        "part_number": "826453-2",
        "name": "Screw 10-32 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2745,
          "y": 0.8098
        },
        "machine_section": 1
      },
      {
        "callout": "18",
        "part_number": "831659",
        "name": "Collector Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1939,
          "y": 0.8039
        },
        "machine_section": 1
      },
      {
        "callout": "19",
        "part_number": "833778",
        "name": "Ball Float",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2669,
          "y": 0.8468
        },
        "machine_section": 1
      },
      {
        "callout": "20",
        "part_number": "830101-1",
        "name": "Filter Cage",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.268,
          "y": 0.862
        },
        "machine_section": 1
      },
      {
        "callout": "21",
        "part_number": "107177",
        "name": "Quick Lock Wet Filter",
        "in_netsuite": true,
        "handle": "proteam-107177-qwik-lock-wet-filter-fits-proguard-10-20-gal",
        "coord": {
          "x": 0.158,
          "y": 0.7929
        },
        "machine_section": 1
      },
      {
        "callout": "22",
        "part_number": "107175",
        "name": "Qwik Lock Fine Dust Cartridge Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1983,
          "y": 0.851
        },
        "machine_section": 1
      },
      {
        "callout": "23",
        "part_number": "831668-1",
        "name": "Tote",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3693,
          "y": 0.6035
        },
        "machine_section": 1
      },
      {
        "callout": "24",
        "part_number": "830686",
        "name": "Handle",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3584,
          "y": 0.7391
        },
        "machine_section": 1
      },
      {
        "callout": "25",
        "part_number": "831660-2",
        "name": "Dust Drum Assembly",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3932,
          "y": 0.8636
        },
        "machine_section": 1
      },
      {
        "callout": "26",
        "part_number": "73185",
        "name": "Drain Cap",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2952,
          "y": 0.862
        },
        "machine_section": 1
      },
      {
        "callout": "27",
        "part_number": "830611",
        "name": "Wheel Cap",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1634,
          "y": 0.8872
        },
        "machine_section": 1
      },
      {
        "callout": "28",
        "part_number": "813836-1",
        "name": "Cap Nut 1/2\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1786,
          "y": 0.8855
        },
        "machine_section": 1
      },
      {
        "callout": "29",
        "part_number": "832190",
        "name": "8\" Wheel Assembly (includes: 27, 28)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1786,
          "y": 0.8998
        },
        "machine_section": 1
      },
      {
        "callout": "30",
        "part_number": "831024",
        "name": "Shaft",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2255,
          "y": 0.8897
        },
        "machine_section": 1
      },
      {
        "callout": "31",
        "part_number": "830577",
        "name": "Left Caddy",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1819,
          "y": 0.9074
        },
        "machine_section": 1
      },
      {
        "callout": "32",
        "part_number": "832123",
        "name": "Caster",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1906,
          "y": 0.9301
        },
        "machine_section": 1
      },
      {
        "callout": "33",
        "part_number": "820563-5",
        "name": "Screw Type \"AB\" #10 x 1-3/4\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2386,
          "y": 0.9242
        },
        "machine_section": 1
      },
      {
        "callout": "34",
        "part_number": "830576",
        "name": "Right Caddy",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3301,
          "y": 0.9116
        },
        "machine_section": 1
      },
      {
        "callout": null,
        "part_number": "509944",
        "name": "Bag of Loose Parts (Not Shown) 1 kit 36.31",
        "in_netsuite": false,
        "handle": null,
        "coord": null,
        "machine_section": 1
      }
    ]
  },
  "ProGuard 15/20": {
    "catalog_page": 41,
    "image_asset": "schematic-41.jpeg",
    "type": "single",
    "parts": [
      {
        "callout": "1",
        "part_number": "510097",
        "name": "Motor Cover Assembly (ProGuard 15)",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2473,
          "y": 0.2273
        }
      },
      {
        "callout": null,
        "part_number": "510104",
        "name": "Motor Cover Assembly (ProGuard 20)",
        "in_netsuite": false,
        "handle": null,
        "coord": null
      },
      {
        "callout": "2",
        "part_number": "830565-2",
        "name": "Handle Motor Cover",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4041,
          "y": 0.1902
        }
      },
      {
        "callout": "3",
        "part_number": "820563-4",
        "name": "Screw Type AB #10 x ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4031,
          "y": 0.2104
        }
      },
      {
        "callout": "4",
        "part_number": "833600",
        "name": "Diffuser Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1808,
          "y": 0.2542
        }
      },
      {
        "callout": "5",
        "part_number": "510127",
        "name": "Switch Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3802,
          "y": 0.2492
        }
      },
      {
        "callout": "6",
        "part_number": "831651",
        "name": "Motor Exhaust Duct",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3715,
          "y": 0.3005
        }
      },
      {
        "callout": "7",
        "part_number": "826453-2",
        "name": "Screw 10-32 X ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3802,
          "y": 0.3215
        }
      },
      {
        "callout": "8",
        "part_number": "830609",
        "name": "Exhaust Foam Pad",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.146,
          "y": 0.3013
        }
      },
      {
        "callout": "9",
        "part_number": "831653-3",
        "name": "Lid",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3922,
          "y": 0.3384
        }
      },
      {
        "callout": "10",
        "part_number": "833417",
        "name": "Power Cord Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1318,
          "y": 0.3367
        }
      },
      {
        "callout": "11",
        "part_number": "822374-8",
        "name": "Carbon Brush Set",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.122,
          "y": 0.3822
        }
      },
      {
        "callout": "12",
        "part_number": "831567",
        "name": "Motor Assembly Complete",
        "in_netsuite": true,
        "handle": "proteam-831567-motor-assembly-complete-proguard",
        "coord": {
          "x": 0.3845,
          "y": 0.3923
        }
      },
      {
        "callout": "13",
        "part_number": "833518",
        "name": "Gasket Lid",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2113,
          "y": 0.3939
        }
      },
      {
        "callout": "14",
        "part_number": "827415",
        "name": "Gasket Motor",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3813,
          "y": 0.4133
        }
      },
      {
        "callout": "15",
        "part_number": "831659",
        "name": "Collector Assembly with Foam",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3965,
          "y": 0.4377
        }
      },
      {
        "callout": "16",
        "part_number": "833778",
        "name": "Ball Float",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4728,
          "y": 0.4529
        }
      },
      {
        "callout": "17",
        "part_number": "830101-1",
        "name": "Filter Cage",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4749,
          "y": 0.4806
        }
      },
      {
        "callout": "18",
        "part_number": "107177",
        "name": "Wet FIlter",
        "in_netsuite": true,
        "handle": "proteam-107177-qwik-lock-wet-filter-fits-proguard-10-20-gal",
        "coord": {
          "x": 0.4728,
          "y": 0.5202
        }
      },
      {
        "callout": "19",
        "part_number": "833603",
        "name": "20 Gallon Tank",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4009,
          "y": 0.6313
        }
      },
      {
        "callout": "20",
        "part_number": "833602",
        "name": "15 Gallon Tank",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4336,
          "y": 0.6279
        }
      },
      {
        "callout": "21",
        "part_number": "833424-1",
        "name": "Drum Latch",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3312,
          "y": 0.4941
        }
      },
      {
        "callout": "22",
        "part_number": "833492-1",
        "name": "Screw 10-32 X ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3932,
          "y": 0.537
        }
      },
      {
        "callout": "23",
        "part_number": "833493",
        "name": "Washer (13/64 ID) #10",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3235,
          "y": 0.5168
        }
      },
      {
        "callout": "24",
        "part_number": "161255-8",
        "name": "Nut Lock #10",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3028,
          "y": 0.5328
        }
      },
      {
        "callout": "25",
        "part_number": "833425",
        "name": "Tank Inlet Adapter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4292,
          "y": 0.569
        }
      },
      {
        "callout": "26",
        "part_number": "833426",
        "name": "Gasket Inlet Adapter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4096,
          "y": 0.5665
        }
      },
      {
        "callout": "27",
        "part_number": "833492",
        "name": "Screw 10-32 X 1 ¼\"",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4586,
          "y": 0.596
        }
      },
      {
        "callout": "28",
        "part_number": "833493",
        "name": "Washer (13/64 ID) #10",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3911,
          "y": 0.5581
        }
      },
      {
        "callout": "29",
        "part_number": "833451",
        "name": "Hose Drain Assembly 30\" (includes: 30)",
        "in_netsuite": true,
        "handle": "proteam-833451-30-hose-drain-assembly",
        "coord": {
          "x": 0.1024,
          "y": 0.5572
        }
      },
      {
        "callout": "30",
        "part_number": "833452",
        "name": "Hose Clamp",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1623,
          "y": 0.58
        }
      },
      {
        "callout": "31",
        "part_number": "826881",
        "name": "Hose Clip",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1721,
          "y": 0.5572
        }
      },
      {
        "callout": "32",
        "part_number": "808872-2",
        "name": "Screw 10-32 X 1 ¼\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1634,
          "y": 0.516
        }
      },
      {
        "callout": "33",
        "part_number": "833449",
        "name": "Cap Rubber Drum Pour Spout",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2135,
          "y": 0.5034
        }
      },
      {
        "callout": "34",
        "part_number": "833450",
        "name": "Pour Spout Cable Lanyard",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.28,
          "y": 0.4832
        }
      },
      {
        "callout": "35",
        "part_number": "833492",
        "name": "Screw 10-32 X 1 ¼\"",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2168,
          "y": 0.4865
        }
      },
      {
        "callout": "36",
        "part_number": "833493",
        "name": "Washer (13/64 ID) #10",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2865,
          "y": 0.4975
        }
      },
      {
        "callout": "37",
        "part_number": "161255-2",
        "name": "Nut Lock 3/8-16",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2974,
          "y": 0.5926
        }
      },
      {
        "callout": "38",
        "part_number": "100371",
        "name": "Cap",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.158,
          "y": 0.6633
        }
      },
      {
        "callout": "39",
        "part_number": "832397-1",
        "name": "Screw Hex 3/8-16 X 3 ¾\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1765,
          "y": 0.6524
        }
      },
      {
        "callout": "40",
        "part_number": "833779",
        "name": "Cap Retainer",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1492,
          "y": 0.6052
        }
      },
      {
        "callout": "41",
        "part_number": "805557-1",
        "name": "Washer 13/32 ID",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2026,
          "y": 0.6448
        }
      },
      {
        "callout": "42",
        "part_number": "833465",
        "name": "Cart Base Handle",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2625,
          "y": 0.1591
        }
      },
      {
        "callout": "43",
        "part_number": "833454",
        "name": "Drum Hinge Bushing",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1928,
          "y": 0.5825
        }
      },
      {
        "callout": "44",
        "part_number": "833456",
        "name": "Cart Base",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.195,
          "y": 0.6709
        }
      },
      {
        "callout": "45",
        "part_number": "833459",
        "name": "10\" Wheel",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1427,
          "y": 0.7323
        }
      },
      {
        "callout": "46",
        "part_number": "833460",
        "name": "Wheel Spacer",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4455,
          "y": 0.6633
        }
      },
      {
        "callout": "47",
        "part_number": "833662",
        "name": "Thumb Screw",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2571,
          "y": 0.7315
        }
      },
      {
        "callout": "48",
        "part_number": "831024-3",
        "name": "Shaft Tube",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4009,
          "y": 0.702
        }
      },
      {
        "callout": "49",
        "part_number": "805466-3",
        "name": "Screw Hex HD 5/16-18 X 5/8\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.2789,
          "y": 0.7652
        }
      },
      {
        "callout": "50",
        "part_number": "140755-12",
        "name": "Lock Washer Ext 5/16\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.341,
          "y": 0.7391
        }
      },
      {
        "callout": "51",
        "part_number": "833461",
        "name": "Axle Bracket",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.268,
          "y": 0.7458
        }
      },
      {
        "callout": "52",
        "part_number": "813836-1",
        "name": "Nut Washer Cap",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.1285,
          "y": 0.7559
        }
      },
      {
        "callout": "53",
        "part_number": "833462",
        "name": "4\" Caster w/Bearings",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.4161,
          "y": 0.7407
        }
      },
      {
        "callout": "54",
        "part_number": "805466-3",
        "name": "Screw Hex HD 5/16-18 X 5/8\"",
        "in_netsuite": false,
        "handle": null,
        "coord": {
          "x": 0.3932,
          "y": 0.766
        }
      },
      {
        "callout": "55",
        "part_number": "833463",
        "name": "Plate Pedal Lock",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.1558,
          "y": 0.681
        }
      },
      {
        "callout": "56",
        "part_number": "833432",
        "name": "50' Extension Cord",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2734,
          "y": 0.8098
        }
      },
      {
        "callout": "57",
        "part_number": "107180",
        "name": "Intercept Micro Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.2331,
          "y": 0.8535
        }
      },
      {
        "callout": "58",
        "part_number": "107175",
        "name": "Qwik Lock Fine Dust Filter",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4597,
          "y": 0.803
        }
      },
      {
        "callout": "59",
        "part_number": "831577",
        "name": "Swivel Hose Cuff 1½\"",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.3595,
          "y": 0.8468
        }
      },
      {
        "callout": "60",
        "part_number": "107198",
        "name": "Hose Assembly",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4292,
          "y": 0.8426
        }
      },
      {
        "callout": "61",
        "part_number": "833587",
        "name": "Locking Ring Cuff",
        "in_netsuite": true,
        "handle": null,
        "coord": {
          "x": 0.4597,
          "y": 0.862
        }
      },
      {
        "callout": null,
        "part_number": "510142",
        "name": "Bag of Loose Parts (Not Shown)",
        "in_netsuite": false,
        "handle": null,
        "coord": null
      }
    ]
  }
};
